"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6171],{

/***/ 26171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BookingSearchBar; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./helpers/class/Calendar.ts
var Calendar = __webpack_require__(74867);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./helpers/class/Dialog.ts
var Dialog = __webpack_require__(42970);
// EXTERNAL MODULE: ./helpers/class/Popover.ts
var Popover = __webpack_require__(22019);
// EXTERNAL MODULE: ./components/templates/index/bookingSearchBar/FullWidthBar.tsx
var FullWidthBar = __webpack_require__(26575);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(1919);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/async-creatable/dist/react-select.esm.js + 1 modules
var dist_react_select_esm = __webpack_require__(7398);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(87091);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog_Dialog = __webpack_require__(4271);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover_Popover = __webpack_require__(97120);
// EXTERNAL MODULE: ../../shared/node_modules/axios/index.js
var axios = __webpack_require__(41690);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/AppContext.tsx
var AppContext = __webpack_require__(1860);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(46093);
// EXTERNAL MODULE: ./components/templates/index/bookingSearchBar/partials/CalendarCheckin.tsx
var CalendarCheckin = __webpack_require__(65305);
// EXTERNAL MODULE: ./components/templates/index/bookingSearchBar/partials/CalendarCheckout.tsx
var CalendarCheckout = __webpack_require__(64239);
// EXTERNAL MODULE: ./components/templates/index/bookingSearchBar/partials/Guests.tsx
var Guests = __webpack_require__(59207);
// EXTERNAL MODULE: ./components/templates/property/content/columned/right/SwipeableDrawerFilters.tsx + 1 modules
var SwipeableDrawerFilters = __webpack_require__(1079);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ../../shared/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(76112);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/templates/index/bookingSearchBar/SliderContainedBar.tsx



























var defaults_load = false;
// export async function getDefaultOptions ( pageId )  {
//   if ( !defaults_load ) {
//     return await axios.get( `/api/lodge/frontend/get/search-suggestions/default?page_id=` + pageId, {
//       headers: {
//         'x-api-key': 'test'
//       }
//     }).then( async (response) => {
//       let defaultLocationValue;
//       const options = [];
//       let data = response.data;
//       await data.forEach( ( suggestion ) => {
//         options.push({
//           label: suggestion.title,
//           value: suggestion.id,
//           slug: suggestion.slug
//         })
//
//
//         if ( suggestion.slug==window.location.pathname ) {
//           defaultLocationValue = {
//             value: suggestion.id,
//             label: suggestion.title,
//             slug: suggestion.slug
//           }
//         }
//       })
//       defaults_load = true;
//       // console.log( defaultLocationValue );
//       return { options, defaultLocationValue };
//     });
//   }
// }
function SliderContainedBar(props) {
    var updateUri = props.hasOwnProperty("updateUri") ? props.updateUri : true;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isMobile = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    var currentDestination = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["currentDestination"];
    });
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    var customSearch = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["search"];
    });
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var destinations = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["destinations"];
    });
    var isHomepage = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isHomepage"];
    });
    var isListingPage = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["isListingPage"];
    });
    var isSearchPage = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["isSearchPage"];
    });
    var pageContext = (0,react.useContext)(AppContext/* page */.M);
    var ref = (0,react.useState)(null), selectedLocation = ref[0], setSelectedLocation = ref[1];
    var searchSpinner = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["searchSpinner"];
    });
    var searchBtnLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_search_btn_label");
    });
    var searchSelectLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_select_label");
    });
    var ref1 = (0,react.useState)(false), removeAllDestinations = ref1[0], setRemoveAllDestinations = ref1[1];
    var ref2 = (0,react.useState)(null), localSearchText = ref2[0], setLocalSearchText = ref2[1];
    var ref3 = (0,react.useState)(null), localDestinationId = ref3[0], setLocalDestinationId = ref3[1];
    var checkin = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var ref4 = (0,react.useState)([
        null,
        null
    ]), localDateRange = ref4[0], setLocalDateRange = ref4[1];
    var bedrooms = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["bedrooms"];
    });
    var ref5 = (0,react.useState)(bedrooms), localBedrooms = ref5[0], setLocalBedrooms = ref5[1];
    var ref6 = (0,react.useState)(0), localAdultsNum = ref6[0], setLocalAdultsNum = ref6[1];
    var ref7 = (0,react.useState)(0), localKidsNum = ref7[0], setLocalKidsNum = ref7[1];
    var ref8 = (0,react.useState)(0), localInfantsNum = ref8[0], setLocalInfantsNum = ref8[1];
    (0,react.useEffect)(function() {
        setLocalAdultsNum(propertiesParams.adults);
        setLocalKidsNum(propertiesParams.kids);
        setLocalInfantsNum(propertiesParams.infants);
    }, [
        propertiesParams
    ]);
    (0,react.useEffect)(function() {
        var checkin_unix = new Date(checkin).valueOf() ? new Date(checkin) : null;
        var checkout_unix = new Date(checkout).valueOf() ? new Date(checkout) : null;
        setLocalDateRange([
            checkin_unix,
            checkout_unix
        ]);
    }, [
        checkin,
        checkout,
        propertiesParams
    ]);
    (0,react.useEffect)(function() {
        setLocalBedrooms(bedrooms);
    }, [
        bedrooms,
        propertiesParams
    ]);
    var dateRangeHandler = function(val) {
        props.calendar.setValue(val);
        props.calendar.focusToggle("close_checkin");
        setLocalDateRange(val);
    };
    var handleInputChange = function(input) {
        var location_val = input.value;
        var location_data = location_val.split("_");
        var location_type = location_data[0];
        var location_id = location_data[1];
        if (location_type == "all") {
            setSelectedLocation(input);
            setRemoveAllDestinations(true);
            setLocalSearchText("");
        } else if (location_type == "destination") {
            setSelectedLocation(input);
            setRemoveAllDestinations(false);
            setLocalDestinationId(location_id);
            setLocalSearchText("");
        } else if (location_type != "property") {
            setSelectedLocation(input);
            setRemoveAllDestinations(true);
            setLocalSearchText(input.label);
        } else {
            var customOption = {
                value: input.label,
                label: input.label
            };
            setSelectedLocation(customOption);
            setRemoveAllDestinations(true);
            setLocalSearchText(input.label);
        }
    };
    var dispatchValues = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (removeAllDestinations) {
                    dispatch((0,actions/* removeAllDestination */.EA)());
                } else if (localDestinationId != null) {
                    dispatch((0,actions/* setDestination */.M)(localDestinationId));
                }
                dispatch((0,actions/* setSearchText */.FD)(localSearchText));
                dispatch((0,actions/* setDateRange */.t5)(localDateRange));
                dispatch((0,actions/* setBedrooms */.ze)(localBedrooms));
                if (localDateRange[0] == null || localDateRange[1] == null) {
                    return [
                        2,
                        false
                    ];
                }
                dispatch((0,actions/* setAdults */.MJ)(localAdultsNum));
                dispatch((0,actions/* setKids */.ob)(localKidsNum));
                dispatch((0,actions/* setInfants */.ZG)(localInfantsNum));
                return [
                    2,
                    true
                ];
            });
        });
        return function dispatchValues() {
            return _ref.apply(this, arguments);
        };
    }();
    var val = 0;
    var searchHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var values, queryString, location_id, location_val, location_data, location_type, queryString1, newUrl, queryString2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatchValues()
                        ];
                    case 1:
                        values = _state.sent();
                        if (props.isHotel || props.isChain) {
                            values ? dispatch((0,actions/* setSearchSpinner */.jo)(true)) : dispatch((0,actions/* setSearchSpinner */.jo)(false));
                            dispatch((0,actions/* setSearchSpinnerTrigger */.o9)(val));
                            return [
                                2
                            ];
                        }
                        dispatch((0,actions/* setOffset */.nb)(0));
                        dispatch((0,actions/* setPageNumber */.oW)(1));
                        propertiesParams.offset = 0;
                        propertiesParams.adults = localAdultsNum;
                        propertiesParams.kids = localKidsNum;
                        propertiesParams.infants = localInfantsNum;
                        propertiesParams.bedrooms = localBedrooms;
                        propertiesParams.search = localSearchText;
                        if (removeAllDestinations) {
                            propertiesParams.destinations = [];
                        } else if (localDestinationId != null) {
                            propertiesParams.destinations = [
                                localDestinationId
                            ];
                        }
                        if (localDateRange[0] != null) {
                            propertiesParams.checkin = dayjs_min_default()(localDateRange[0]).format("YYYY-MM-DD");
                        } else {
                            propertiesParams.checkin = null;
                        }
                        if (localDateRange[1] != null) {
                            propertiesParams.checkout = dayjs_min_default()(localDateRange[1]).format("YYYY-MM-DD");
                        } else {
                            propertiesParams.checkout = null;
                        }
                        if (selectedLocation == null && !isSearchPage) {
                            queryString = Checkers/* default.serialize */.Z.serialize(propertiesParams);
                            router.push("/properties/search/?" + queryString);
                            event.preventDefault();
                            return [
                                2
                            ];
                        }
                        location_id = "";
                        location_val = "";
                        if (selectedLocation != null) {
                            location_val = selectedLocation.value;
                            location_data = location_val.split("_");
                            location_type = location_data[0];
                            location_id = location_data[1];
                        }
                        dispatch((0,actions/* setSearchSpinner */.jo)(true));
                        if (isListingPage && currentDestination == propertiesParams.destinations[0] && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(location_id)) {
                            dispatch((0,actions/* setLoadingProperties */.Po)(true));
                            dispatch((0,actions/* fetchPropertiesAction */.SH)(propertiesParams));
                            dispatch((0,actions/* setApplyParams */.DY)(1));
                        } else if (isSearchPage) {
                            dispatch((0,actions/* setLoadingProperties */.Po)(true));
                            dispatch((0,actions/* fetchPropertiesAction */.SH)(propertiesParams));
                            dispatch((0,actions/* setApplyParams */.DY)(1));
                            queryString1 = Checkers/* default.serialize */.Z.serialize(propertiesParams);
                            propertiesParams.search = location_val;
                            newUrl = "/properties/search/?" + queryString1;
                            if (updateUri) {
                                window.history.replaceState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, window.history.state), {
                                    as: newUrl,
                                    url: newUrl
                                }), "", newUrl);
                            }
                        } else {
                            queryString2 = Checkers/* default.serialize */.Z.serialize(propertiesParams);
                            propertiesParams.search = location_val;
                            router.push("/properties/search/?" + queryString2);
                        }
                        event.preventDefault();
                        return [
                            2
                        ];
                }
            });
        });
        return function searchHandler(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var popoverText = [];
        var adults = localAdultsNum;
        if (adults > 0) {
            popoverText.push(adults + (adults > 1 ? " adults" : " adult"));
        }
        var kids = localKidsNum;
        if (kids > 0) {
            popoverText.push(kids + (kids > 1 ? " kids" : " kid"));
        }
        var infants = localInfantsNum;
        if (infants > 0) {
            popoverText.push(infants + (infants > 1 ? " infants" : " infant"));
        }
        if (popoverText.length > 0) {
            props.popover.guestsSetText(popoverText.join(", "));
        } else {
            props.popover.guestsSetText("Who will stay");
        }
    }, [
        localAdultsNum,
        localKidsNum,
        localInfantsNum
    ]);
    var loadOptions = function(inputValue, callback) {
        axios_default().post("/apiloggia", {
            action: "/api/lodge/frontend/get/search-suggestions/all?page_id=" + pageContext.pageId + "&search=" + encodeURIComponent(inputValue),
            useCache: false
        }).then(function(response) {
            var options = [];
            var data = response.data;
            data = data.filter(function(i) {
                return i.title.toLowerCase().includes(inputValue.toLowerCase());
            });
            data.forEach(function(suggestion) {
                options.push({
                    label: suggestion.title,
                    value: suggestion.id,
                    slug: suggestion.slug
                });
            });
            callback(options);
        });
    };
    var ref9 = (0,react.useState)(null), defaults = ref9[0], setDefaults = ref9[1];
    (0,react.useEffect)(function() {
        (0,FullWidthBar/* getDefaultOptions */.j)(pageId).then(function(response) {
            setDefaults(response.options);
            var destination = Checkers/* default.isValidArray */.Z.isValidArray(destinations) ? destinations[0] : null;
            var destinationFlag = false;
            Checkers/* default.isValidArray */.Z.isValidArray(response.options) && response.options.map(function(item) {
                if (item.value == "destination_" + destination) {
                    setSelectedLocation(item);
                    destinationFlag = true;
                }
            });
            if (Checkers/* default.isValidString */.Z.isValidString(customSearch) && !destinationFlag) {
                var customOption = {
                    value: customSearch,
                    label: customSearch
                };
                setSelectedLocation(customOption);
            } else if (!destinationFlag) {
                var customOption1 = {
                    value: "all_properties",
                    label: "All properties"
                };
                setSelectedLocation(customOption1);
            } else if (destinationFlag) {
                setLocalDestinationId(destination);
            }
        });
    }, [
        destinations,
        propertiesParams
    ]);
    var searchbarRadius = "10px";
    if (props.searchbarRadius != null) {
        searchbarRadius = props.searchbarRadius + "px";
    }
    var searchBarRowClass = "SearchBar-Form__row ";
    searchBarRowClass += props.padding != null ? props.containerClass != null && props.containerClass.match("container-fluid") ? "row bg-white w-100 no-margin padding-".concat(props.padding, " md-p-r-24") : "row bg-white w-100 no-margin padding-".concat(props.padding, " md-p-r-18") : "row bg-white w-100 no-margin padding-20";
    Calendar/* default.setProps */.Z.setProps(props);
    var calendarMaterialTheme = Calendar/* default.getCalendarMaterialTheme */.Z.getCalendarMaterialTheme;
    var calendar = {
        customTheme: calendarMaterialTheme
    };
    return isMobile ? props.isHomePage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeableDrawerFilters/* default */.Z, {
        calendar: calendar
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row justify-content-center w-100 no-margin",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: isHomepage ? "col-12 col-md-8 p-0" : "col-12 col-md-12 p-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center w-100 no-margin",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: props.sliderSearchBarFullWidth ? "col-12 p-0" : "col-12 col-md-12 p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            id: "frm_book",
                            onSubmit: function(event) {
                                return searchHandler(event);
                            },
                            className: "test-3 needs-validation position-relative SearchBar-Form",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: searchBarRowClass,
                                style: {
                                    borderRadius: props.searchbarRadius != null ? props.searchbarRadius + "px" : "10px",
                                    boxShadow: props.noShadow ? "none" : props.searchbarShadow != null ? "0px 0px " + props.searchbarShadow + "px #CCC" : "0px 0px 8px #CCC",
                                    zIndex: "10"
                                },
                                children: [
                                    props.isManager == true && !props.isHotel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "SearchBar-Form__column col-12 col-md-4 col-lg-4 h-100 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0 pb-xs-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "SearchBar-Form__form-group form-group form-group-default form-group-default-select2 no-margin no-border no-arrow overflow-visible fs-14",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    htmlFor: "location_property",
                                                    id: "location_property_id",
                                                    className: "form-label bold mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            className: "hidden-md",
                                                            icon: pro_regular_svg_icons/* faMapMarkerAlt */.FGq
                                                        }),
                                                        " ",
                                                        Checkers/* default.isValidString */.Z.isValidString(searchSelectLabel) ? searchSelectLabel : "Location/Property"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_react_select_esm/* default */.Z, {
                                                    cacheOptions: false,
                                                    defaultOptions: defaults,
                                                    loadOptions: loadOptions,
                                                    onChange: handleInputChange,
                                                    value: selectedLocation,
                                                    className: "SearchBar-Form__form-group-select",
                                                    id: "location_property",
                                                    name: "location_property",
                                                    inputId: "location_property",
                                                    instanceId: "location_property",
                                                    isSearchable: true,
                                                    options: props.options,
                                                    styles: props.customStyles,
                                                    placeholder: "Where are you going",
                                                    blurInputOnSelect: true,
                                                    menuPlacement: "bottom",
                                                    formatCreateLabel: function(inputValue) {
                                                        return "Search for " + inputValue;
                                                    },
                                                    components: {
                                                        DropdownIndicator: function() {
                                                            return null;
                                                        },
                                                        IndicatorSeparator: function() {
                                                            return null;
                                                        }
                                                    }
                                                })
                                            ]
                                        })
                                    }) : "",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: props.isManager == true && props.isHotel == undefined ? "SearchBar-Form__column col-12 col-md-5 col-lg-5 h-100 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0 pb-xs-2" : "SearchBar-Form__column col-12 col-md-8 col-lg-8 h-100 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0 pb-xs-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row form-group-attached no-margin no-border",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-6 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        id: "form-group-default-checkin",
                                                        className: "SearchBar-Form__form-group form-group form-group-default form-group-default-checkin no-border no-margin",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                id: "checkin_label",
                                                                className: "form-label bold",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        className: "hidden-md",
                                                                        icon: pro_regular_svg_icons/* faCalendar */.fT7
                                                                    }),
                                                                    " Check in"
                                                                ]
                                                            }),
                                                            props.hasOwnProperty("calendar") && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarCheckin/* default */.Z, {
                                                                dateRange: localDateRange,
                                                                setDateRange: dateRangeHandler,
                                                                customTheme: props.calendar.customTheme,
                                                                focusToggle: props.calendar.focusToggle,
                                                                disableAllDatesAfterTwoYears: props.calendar.disableAllDatesAfterTwoYears
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-6 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        id: "form-group-default-checkout",
                                                        className: "SearchBar-Form__form-group form-group form-group-default form-group-default-checkout no-border no-margin",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                id: "checkout_label",
                                                                className: "form-label bold",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        className: "hidden-md",
                                                                        icon: pro_regular_svg_icons/* faCalendar */.fT7
                                                                    }),
                                                                    " Check out"
                                                                ]
                                                            }),
                                                            props.hasOwnProperty("calendar") && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarCheckout/* default */.Z, {
                                                                dateRange: localDateRange,
                                                                setDateRange: dateRangeHandler,
                                                                customTheme: props.calendar.customTheme,
                                                                focusToggle: props.calendar.focusToggle,
                                                                disableAllDatesAfterTwoYears: props.calendar.disableAllDatesAfterTwoYears
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: props.isManager == true && props.isHotel === undefined ? "SearchBar-Form__column col-12 col-md-3 col-lg-3 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0" : "SearchBar-Form__column col-12 col-md-4 col-lg-4 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: props.bookingSearchbarWithBedrooms ? "SearchBar-Form__form-group overflow-visible form-group form-group-default form-group-default-select2 input-group-attached no-border no-margin overflow-visible" : "SearchBar-Form__form-group overflow-visible form-group form-group-default input-group-attached no-border no-margin",
                                            children: [
                                                props.bookingSearchbarWithBedrooms ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            htmlFor: "bedrooms",
                                                            className: "form-label bold",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                    className: "hidden-md",
                                                                    icon: pro_regular_svg_icons/* faBed */.by_
                                                                }),
                                                                " Bedrooms"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm["default"], {
                                                            name: "bedrooms",
                                                            value: (0,MethodHelper/* getBedroomValue */.r$)(bedrooms, props.bedroomOptions),
                                                            inputId: "bedrooms",
                                                            isSearchable: true,
                                                            options: props.bedroomOptions,
                                                            styles: props.customStyles,
                                                            onChange: function(newValue) {
                                                                (0,MethodHelper/* updateBedrooms */.tC)(newValue, dispatch);
                                                            },
                                                            blurInputOnSelect: true,
                                                            components: {
                                                                DropdownIndicator: function() {
                                                                    return null;
                                                                },
                                                                IndicatorSeparator: function() {
                                                                    return null;
                                                                }
                                                            }
                                                        })
                                                    ]
                                                }) : props.hasOwnProperty("popover") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            id: "guests_label",
                                                            htmlFor: "guests",
                                                            className: "form-label bold",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                    className: "hidden-md",
                                                                    icon: pro_regular_svg_icons/* faUserFriends */.r$M
                                                                }),
                                                                " Guests"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "w-100 fs-14 fw-normal no-margin text-master text-truncate opacity-70 hidden-xs hidden-sm",
                                                            onClick: props.popover.handleOpen,
                                                            "aria-describedby": props.popover.id,
                                                            style: {
                                                                cursor: "pointer"
                                                            },
                                                            children: props.popover.guestsText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "w-100 fw-normal text-master text-truncate fs-14 no-margin opacity-70 visible-xs visible-sm visible-md",
                                                            onClick: props.dialog.handleOpen,
                                                            style: {
                                                                cursor: "pointer"
                                                            },
                                                            children: props.popover.guestsText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover_Popover/* default */.ZP, {
                                                            className: "hidden-xs hidden-sm",
                                                            id: props.popover.id,
                                                            open: props.popover.open,
                                                            anchorEl: props.popover.anchorEl,
                                                            onClose: props.popover.handleClose,
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left"
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Guests/* default */.Z, {
                                                                popover: props.popover,
                                                                dialog: props.dialog,
                                                                mobile: false,
                                                                dispatchValues: false,
                                                                adultsNum: localAdultsNum,
                                                                kidsNum: localKidsNum,
                                                                infantsNum: localInfantsNum,
                                                                setAdultsNum: setLocalAdultsNum,
                                                                setKidsNum: setLocalKidsNum,
                                                                setInfantsNum: setLocalInfantsNum
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog_Dialog/* default */.Z, {
                                                            onClose: props.dialog.handleClose,
                                                            open: props.dialog.open,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Guests/* default */.Z, {
                                                                popover: props.popover,
                                                                dialog: props.dialog,
                                                                mobile: true,
                                                                dispatchValues: false,
                                                                adultsNum: localAdultsNum,
                                                                kidsNum: localKidsNum,
                                                                infantsNum: localInfantsNum,
                                                                setAdultsNum: setLocalAdultsNum,
                                                                setKidsNum: setLocalKidsNum,
                                                                setInfantsNum: setLocalInfantsNum
                                                            })
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "input-group-btn",
                                                    style: {
                                                        right: "0!important"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        form: "frm_book",
                                                        onClick: function(event) {
                                                            return searchHandler(event);
                                                        },
                                                        className: "btn btn-primary btn-cons btn-design-color btn-search-color h-100 hidden-xs hidden-sm visible-md visible-lg visible-xl visible-xxl " + props.textColor,
                                                        style: {
                                                            borderRadius: searchbarRadius,
                                                            minWidth: 50,
                                                            minHeight: 50
                                                        },
                                                        "aria-label": "Search",
                                                        type: props.isChain || props.isHotel ? "button" : "submit",
                                                        children: !searchSpinner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: !props.searchbarThemeColor ? "text-white" : props.textColor,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                    icon: pro_regular_svg_icons/* faSearch */.wn1,
                                                                    className: "visible-md visible-lg visible-xl m-auto"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "hidden-md hidden-lg hidden-xl",
                                                                    children: Checkers/* default.isValidString */.Z.isValidString(searchBtnLabel) ? searchBtnLabel : "Search"
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: !props.searchbarThemeColor ? "text-white" : props.textColor,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: pro_regular_svg_icons/* faSpinner */.LM3,
                                                                spin: true,
                                                                className: "m-auto"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-12 col-md-2 h-100 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0 mt-2 hidden-md hidden-lg hidden-xl hidden-xxl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            form: "frm_book",
                                            // onClick={event => searchHandler( event )}
                                            className: "btn btn-primary btn-cons btn-design-color btn-search-color h-100 w-100 " + props.textColor,
                                            style: {
                                                minHeight: 50,
                                                borderRadius: searchbarRadius
                                            },
                                            "aria-label": "Search",
                                            type: "submit",
                                            children: !searchSpinner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: !props.searchbarThemeColor ? "text-white" : props.textColor,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_regular_svg_icons/* faSearch */.wn1,
                                                        className: "m-r-5"
                                                    }),
                                                    Checkers/* default.isValidString */.Z.isValidString(searchBtnLabel) ? searchBtnLabel : "Search"
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: !props.searchbarThemeColor ? "text-white" : props.textColor,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_regular_svg_icons/* faSpinner */.LM3,
                                                        spin: true,
                                                        className: "m-r-5"
                                                    }),
                                                    " Searching"
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-select/async/dist/react-select.esm.js
var async_dist_react_select_esm = __webpack_require__(48453);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js + 2 modules
var ThemeProvider = __webpack_require__(2753);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(8019);
;// CONCATENATED MODULE: ./components/templates/index/bookingSearchBar/UnderSliderContainedBar.tsx

























function UnderSliderContainedBar(props) {
    var updateUri = props.hasOwnProperty("updateUri") ? props.updateUri : true;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var currentDestination = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["currentDestination"];
    });
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    var customSearch = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["search"];
    });
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var destinations = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["destinations"];
    });
    var isListingPage = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["isListingPage"];
    });
    var isSearchPage = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["isSearchPage"];
    });
    var ref = (0,react.useState)(null), selectedLocation = ref[0], setSelectedLocation = ref[1];
    var bookingBarRef = (0,react.useRef)();
    var ref1 = (0,react.useState)(null), bookingBarDiv = ref1[0], setBookingBarDiv = ref1[1];
    var searchBtnLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_search_btn_label");
    });
    var searchSpinner = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["searchSpinner"];
    });
    var searchSelectLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_select_label");
    });
    var ref2 = (0,react.useState)(false), removeAllDestinations = ref2[0], setRemoveAllDestinations = ref2[1];
    var ref3 = (0,react.useState)(null), localSearchText = ref3[0], setLocalSearchText = ref3[1];
    var ref4 = (0,react.useState)(null), localDestinationId = ref4[0], setLocalDestinationId = ref4[1];
    var checkin = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var ref5 = (0,react.useState)([
        null,
        null
    ]), localDateRange = ref5[0], setLocalDateRange = ref5[1];
    var bedrooms = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["bedrooms"];
    });
    var ref6 = (0,react.useState)(bedrooms), localBedrooms = ref6[0], setLocalBedrooms = ref6[1];
    var ref7 = (0,react.useState)(0), localAdultsNum = ref7[0], setLocalAdultsNum = ref7[1];
    var ref8 = (0,react.useState)(0), localKidsNum = ref8[0], setLocalKidsNum = ref8[1];
    var ref9 = (0,react.useState)(0), localInfantsNum = ref9[0], setLocalInfantsNum = ref9[1];
    (0,react.useEffect)(function() {
        setLocalAdultsNum(propertiesParams.adults);
        setLocalKidsNum(propertiesParams.kids);
        setLocalInfantsNum(propertiesParams.infants);
    }, [
        propertiesParams
    ]);
    (0,react.useEffect)(function() {
        var checkin_unix = new Date(checkin).valueOf() ? new Date(checkin) : null;
        var checkout_unix = new Date(checkout).valueOf() ? new Date(checkout) : null;
        setLocalDateRange([
            checkin_unix,
            checkout_unix
        ]);
    }, [
        checkin,
        checkout,
        propertiesParams
    ]);
    (0,react.useEffect)(function() {
        setLocalBedrooms(bedrooms);
    }, [
        bedrooms,
        propertiesParams
    ]);
    var dateRangeHandler = function(val) {
        props.calendar.setValue(val);
        props.calendar.focusToggle("close_checkin");
        setLocalDateRange(val);
    };
    var handleInputChange = function(input) {
        var location_val = input.value;
        var location_data = location_val.split("_");
        var location_type = location_data[0];
        var location_id = location_data[1];
        if (location_type == "all") {
            setSelectedLocation(input);
            setRemoveAllDestinations(true);
            setLocalSearchText("");
        } else if (location_type == "destination") {
            setSelectedLocation(input);
            setRemoveAllDestinations(false);
            setLocalDestinationId(location_id);
            setLocalSearchText("");
        } else if (location_type != "property") {
            setSelectedLocation(input);
            setRemoveAllDestinations(true);
            setLocalSearchText(input.label);
        } else {
            var customOption = {
                value: input.label,
                label: input.label
            };
            setSelectedLocation(customOption);
            setRemoveAllDestinations(true);
            setLocalSearchText(input.label);
        }
    };
    var dispatchValues = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (removeAllDestinations) {
                    dispatch((0,actions/* removeAllDestination */.EA)());
                } else if (localDestinationId != null) {
                    dispatch((0,actions/* setDestination */.M)(localDestinationId));
                }
                dispatch((0,actions/* setSearchText */.FD)(localSearchText));
                dispatch((0,actions/* setDateRange */.t5)(localDateRange));
                dispatch((0,actions/* setBedrooms */.ze)(localBedrooms));
                dispatch((0,actions/* setAdults */.MJ)(localAdultsNum));
                dispatch((0,actions/* setKids */.ob)(localKidsNum));
                dispatch((0,actions/* setInfants */.ZG)(localInfantsNum));
                return [
                    2,
                    true
                ];
            });
        });
        return function dispatchValues() {
            return _ref.apply(this, arguments);
        };
    }();
    var searchHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var queryString, location_id, location_val, location_data, location_type, queryString1, newUrl, queryString2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatchValues()
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,actions/* setOffset */.nb)(0));
                        dispatch((0,actions/* setPageNumber */.oW)(1));
                        propertiesParams.offset = 0;
                        propertiesParams.adults = localAdultsNum;
                        propertiesParams.kids = localKidsNum;
                        propertiesParams.infants = localInfantsNum;
                        propertiesParams.bedrooms = localBedrooms;
                        propertiesParams.search = localSearchText;
                        if (removeAllDestinations) {
                            propertiesParams.destinations = [];
                        } else if (localDestinationId != null) {
                            propertiesParams.destinations = [
                                localDestinationId
                            ];
                        }
                        if (localDateRange[0] != null) {
                            propertiesParams.checkin = dayjs_min_default()(localDateRange[0]).format("YYYY-MM-DD");
                        } else {
                            propertiesParams.checkin = null;
                        }
                        if (localDateRange[1] != null) {
                            propertiesParams.checkout = dayjs_min_default()(localDateRange[1]).format("YYYY-MM-DD");
                        } else {
                            propertiesParams.checkout = null;
                        }
                        if (selectedLocation == null && !isSearchPage) {
                            queryString = Checkers/* default.serialize */.Z.serialize(propertiesParams);
                            router.push("/properties/search/?" + queryString);
                            event.preventDefault();
                            return [
                                2
                            ];
                        }
                        location_id = "";
                        location_val = "";
                        if (selectedLocation != null) {
                            location_val = selectedLocation.value;
                            location_data = location_val.split("_");
                            location_type = location_data[0];
                            location_id = location_data[1];
                        }
                        dispatch((0,actions/* setSearchSpinner */.jo)(true));
                        if (isListingPage && currentDestination == propertiesParams.destinations[0] && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(location_id)) {
                            dispatch((0,actions/* setLoadingProperties */.Po)(true));
                            dispatch((0,actions/* fetchPropertiesAction */.SH)(propertiesParams));
                            dispatch((0,actions/* setApplyParams */.DY)(1));
                        } else if (isSearchPage) {
                            dispatch((0,actions/* setLoadingProperties */.Po)(true));
                            dispatch((0,actions/* fetchPropertiesAction */.SH)(propertiesParams));
                            dispatch((0,actions/* setApplyParams */.DY)(1));
                            queryString1 = Checkers/* default.serialize */.Z.serialize(propertiesParams);
                            propertiesParams.search = location_val;
                            newUrl = "/properties/search/?" + queryString1;
                            if (updateUri) {
                                window.history.replaceState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, window.history.state), {
                                    as: newUrl,
                                    url: newUrl
                                }), "", newUrl);
                            }
                        } else {
                            queryString2 = Checkers/* default.serialize */.Z.serialize(propertiesParams);
                            propertiesParams.search = location_val;
                            router.push("/properties/search/?" + queryString2);
                        }
                        event.preventDefault();
                        return [
                            2
                        ];
                }
            });
        });
        return function searchHandler(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var popoverText = [];
        var adults = localAdultsNum + localKidsNum;
        if (adults > 0) {
            popoverText.push(adults + " adults");
        }
        var infants = localInfantsNum;
        if (infants > 0) {
            popoverText.push(infants + " infants");
        }
        if (popoverText.length > 0) {
            props.popover.guestsSetText(popoverText.join(", "));
        } else {
            props.popover.guestsSetText("Who will stay");
        }
    }, [
        localAdultsNum,
        localKidsNum,
        localInfantsNum
    ]);
    var loadOptions = function(inputValue, callback) {
        (0,client/* loadSearchOptionsAction */.gV)(pageId, inputValue, callback);
    };
    var ref10 = (0,react.useState)(null), defaults = ref10[0], setDefaults = ref10[1];
    (0,react.useEffect)(function() {
        (0,FullWidthBar/* getDefaultOptions */.j)(pageId).then(function(response) {
            setDefaults(response.options);
            var destination = Checkers/* default.isValidArray */.Z.isValidArray(destinations) ? destinations[0] : null;
            var destinationFlag = false;
            Checkers/* default.isValidArray */.Z.isValidArray(response.options) && response.options.map(function(item) {
                if (item.value == "destination_" + destination) {
                    setSelectedLocation(item);
                    destinationFlag = true;
                }
            });
            if (Checkers/* default.isValidString */.Z.isValidString(customSearch) && !destinationFlag) {
                var customOption = {
                    value: customSearch,
                    label: customSearch
                };
                setSelectedLocation(customOption);
            } else if (!destinationFlag) {
                var customOption1 = {
                    value: "all_properties",
                    label: "All properties"
                };
                setSelectedLocation(customOption1);
            }
        });
    }, [
        destinations,
        propertiesParams
    ]);
    var searchbarRadius = "10px";
    if (props.searchbarRadius != null) {
        searchbarRadius = props.searchbarRadius + "px";
    }
    var setNextElementPaddingTop = function(nextElem, nextElemPaddingTop, bookingBarHeight) {
        var paddingTop = 0;
        paddingTop = parseInt(String(bookingBarHeight)) / 2 + parseInt(nextElemPaddingTop);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // nextElem.style.setProperty( 'padding-top', `${paddingTop}px`, 'important' );
    };
    (0,react.useEffect)(function() {
        if (window !== undefined) {
            var bookingBarHeight = 0;
            setBookingBarDiv(bookingBarRef === null || bookingBarRef === void 0 ? void 0 : bookingBarRef.current);
            if (bookingBarDiv) {
                bookingBarHeight = bookingBarDiv === null || bookingBarDiv === void 0 ? void 0 : bookingBarDiv.getBoundingClientRect().height;
                var nextElem = bookingBarDiv.offsetParent.offsetParent.nextSibling;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                while(nextElem.style === undefined){
                    nextElem = nextElem.nextSibling;
                }
                var nextElemPaddingTop = window.getComputedStyle(nextElem, null).getPropertyValue("padding-top").split("px")[0];
                setNextElementPaddingTop(nextElem, nextElemPaddingTop, bookingBarHeight);
                window.addEventListener("resize", function() {
                    bookingBarHeight = bookingBarDiv === null || bookingBarDiv === void 0 ? void 0 : bookingBarDiv.getBoundingClientRect().height;
                    setNextElementPaddingTop(nextElem, nextElemPaddingTop, bookingBarHeight);
                });
            }
        }
    }, [
        bookingBarDiv
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: bookingBarRef,
        className: "row justify-content-center w-100 no-margin",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-12 col-lg-12 col-xl-10",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                id: "frm_book",
                onSubmit: function(event) {
                    return searchHandler(event);
                },
                className: "needs-validation",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row bg-white padding-20",
                    style: {
                        borderRadius: props.searchbarRadius != null ? props.searchbarRadius + "px" : "10px",
                        boxShadow: props.searchbarShadow != null ? "0px 0px " + props.searchbarShadow + "px #CCC" : "0px 0px 8px #CCC",
                        zIndex: "10"
                    },
                    children: [
                        props.isManager == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 col-md-4 col-lg-4 h-100 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0 pb-xs-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-group form-group-default form-group-default-select2 no-margin no-border no-arrow overflow-visible",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        htmlFor: "location_property",
                                        className: "form-label bold mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_regular_svg_icons/* faMapMarkerAlt */.FGq
                                            }),
                                            " ",
                                            Checkers/* default.isValidString */.Z.isValidString(searchSelectLabel) ? searchSelectLabel : "Location/Property"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(async_dist_react_select_esm/* default */.Z, {
                                        noOptionsMessage: function() {
                                            return "nothing found";
                                        },
                                        loadingMessage: function() {
                                            return "searching...";
                                        },
                                        cacheOptions: false,
                                        defaultOptions: defaults,
                                        loadOptions: loadOptions,
                                        onChange: handleInputChange,
                                        value: selectedLocation,
                                        className: "SearchBar-Form__form-group-select",
                                        id: "location_property",
                                        name: "location_property",
                                        inputId: "location_property",
                                        instanceId: "location_property",
                                        isSearchable: true,
                                        options: props.options,
                                        styles: props.customStyles,
                                        placeholder: "Where are you going",
                                        blurInputOnSelect: true,
                                        menuPlacement: "bottom",
                                        components: {
                                            DropdownIndicator: function() {
                                                return null;
                                            },
                                            IndicatorSeparator: function() {
                                                return null;
                                            }
                                        }
                                    })
                                ]
                            })
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: props.isManager == true ? "col-12 col-md-5 col-lg-5 h-100 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0 pb-xs-2" : "col-12 col-md-8 col-lg-8 h-100 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0 pb-xs-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row form-group-attached no-margin no-border",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            id: "form-group-default-checkin",
                                            className: "form-group form-group-default form-group-default-checkin no-border no-margin",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    id: "checkin_label",
                                                    className: "form-label bold",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: pro_regular_svg_icons/* faCalendar */.fT7
                                                        }),
                                                        " Check in"
                                                    ]
                                                }),
                                                props.hasOwnProperty("calendar") && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarCheckin/* default */.Z, {
                                                    dateRange: localDateRange,
                                                    setDateRange: dateRangeHandler,
                                                    customTheme: props.calendar.customTheme,
                                                    focusToggle: props.calendar.focusToggle,
                                                    disableAllDatesAfterTwoYears: props.calendar.disableAllDatesAfterTwoYears
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            id: "form-group-default-checkout",
                                            className: "form-group form-group-default form-group-default-checkout no-border no-margin",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    id: "checkout_label",
                                                    className: "form-label bold",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: pro_regular_svg_icons/* faCalendar */.fT7
                                                        }),
                                                        " Check out"
                                                    ]
                                                }),
                                                props.hasOwnProperty("calendar") && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarCheckout/* default */.Z, {
                                                    dateRange: localDateRange,
                                                    setDateRange: dateRangeHandler,
                                                    customTheme: props.calendar.customTheme,
                                                    focusToggle: props.calendar.focusToggle,
                                                    disableAllDatesAfterTwoYears: props.calendar.disableAllDatesAfterTwoYears
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: props.isManager == true ? "col-12 col-md-3 col-lg-3 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0" : "col-12 col-md-4 col-lg-4 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: props.bookingSearchbarWithBedrooms ? "overflow-visible form-group form-group-default form-group-default-select2 input-group-attached no-border no-margin overflow-visible" : "overflow-visible form-group form-group-default input-group-attached no-border no-margin",
                                children: [
                                    props.bookingSearchbarWithBedrooms ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                htmlFor: "bedrooms",
                                                className: "form-label " + props.textColor,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_regular_svg_icons/* faBed */.by_
                                                    }),
                                                    " Bedrooms"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm["default"], {
                                                name: "bedrooms",
                                                value: (0,MethodHelper/* getBedroomValue */.r$)(bedrooms, props.bedroomOptions),
                                                inputId: "bedrooms",
                                                isSearchable: true,
                                                options: props.bedroomOptions,
                                                styles: props.customStyles,
                                                onChange: function(newValue) {
                                                    (0,MethodHelper/* updateBedrooms */.tC)(newValue, dispatch);
                                                },
                                                blurInputOnSelect: true,
                                                components: {
                                                    DropdownIndicator: function() {
                                                        return null;
                                                    },
                                                    IndicatorSeparator: function() {
                                                        return null;
                                                    }
                                                }
                                            })
                                        ]
                                    }) : props.hasOwnProperty("popover") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                id: "guests_label",
                                                className: "form-label bold",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_regular_svg_icons/* faUserFriends */.r$M
                                                    }),
                                                    " Guests"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "w-100 fs-14 fw-normal no-margin text-master text-truncate opacity-70 hidden-xs hidden-sm",
                                                onClick: props.popover.handleOpen,
                                                "aria-describedby": props.popover.id,
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: props.popover.guestsText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "w-100 fw-normal text-master text-truncate fs-14 no-margin opacity-70 visible-xs visible-sm visible-md",
                                                onClick: props.dialog.handleOpen,
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: props.popover.guestsText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                                                theme: props.popover.customTheme,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover_Popover/* default */.ZP, {
                                                    className: "hidden-xs hidden-sm",
                                                    id: props.popover.id,
                                                    open: props.popover.open,
                                                    anchorEl: props.popover.anchorEl,
                                                    onClose: props.popover.handleClose,
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left"
                                                    },
                                                    transformOrigin: {
                                                        vertical: "top",
                                                        horizontal: "left"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Guests/* default */.Z, {
                                                        popover: props.popover,
                                                        dialog: props.dialog,
                                                        mobile: false,
                                                        dispatchValues: false,
                                                        adultsNum: localAdultsNum,
                                                        kidsNum: localKidsNum,
                                                        infantsNum: localInfantsNum,
                                                        setAdultsNum: setLocalAdultsNum,
                                                        setKidsNum: setLocalKidsNum,
                                                        setInfantsNum: setLocalInfantsNum
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog_Dialog/* default */.Z, {
                                                onClose: props.dialog.handleClose,
                                                open: props.dialog.open,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Guests/* default */.Z, {
                                                    popover: props.popover,
                                                    dialog: props.dialog,
                                                    mobile: true,
                                                    dispatchValues: false,
                                                    adultsNum: localAdultsNum,
                                                    kidsNum: localKidsNum,
                                                    infantsNum: localInfantsNum,
                                                    setAdultsNum: setLocalAdultsNum,
                                                    setKidsNum: setLocalKidsNum,
                                                    setInfantsNum: setLocalInfantsNum
                                                })
                                            })
                                        ]
                                    }) : "",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "input-group-btn",
                                        style: {
                                            right: "0!important"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            form: "frm_book",
                                            className: "btn btn-primary btn-cons btn-design-color btn-search-color h-100 hidden-xs hidden-sm visible-md visible-lg visible-xl visible-xxl " + props.textColor,
                                            style: {
                                                minWidth: "52px!important",
                                                minHeight: "50px!important",
                                                borderRadius: searchbarRadius
                                            },
                                            type: "submit",
                                            "aria-label": "search",
                                            children: !searchSpinner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_regular_svg_icons/* faSearch */.wn1
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_regular_svg_icons/* faSpinner */.LM3,
                                                spin: true
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 col-md-2 h-100 ps-xs-0 pe-xs-0 ps-sm-0 pe-sm-0 mt-2 hidden-md hidden-lg hidden-xl hidden-xxl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                form: "frm_book",
                                className: "btn btn-primary btn-cons btn-design-color btn-search-color h-100 w-100 " + props.textColor,
                                style: {
                                    minHeight: "52px!important",
                                    borderRadius: searchbarRadius
                                },
                                "aria-label": "Search",
                                type: "submit",
                                children: !searchSpinner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_regular_svg_icons/* faSearch */.wn1,
                                            className: "m-r-5"
                                        }),
                                        " ",
                                        Checkers/* default.isValidString */.Z.isValidString(searchBtnLabel) ? searchBtnLabel : "Search"
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_regular_svg_icons/* faSpinner */.LM3,
                                            spin: true,
                                            className: "m-r-5"
                                        }),
                                        " Searching"
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/index/BookingSearchBar.tsx














function BookingSearchBar(props) {
    // useEffect( () => {
    //   console.log("props.bookingSearchbarWithBedrooms", props.bookingSearchbarWithBedrooms, "BookingSearchBar")
    // })
    var updateUri = props.hasOwnProperty("updateUri") ? props.updateUri : true;
    Calendar/* default.setProps */.Z.setProps(props);
    Popover/* default.setProps */.Z.setProps(props);
    Dialog/* default.setProps */.Z.setProps(props);
    var calendarMaterialTheme = Calendar/* default.getCalendarMaterialTheme */.Z.getCalendarMaterialTheme;
    var popoverMaterialTheme = Popover/* default.getPopoverMaterialTheme */.Z.getPopoverMaterialTheme;
    var dialogMaterialTheme = Dialog/* default.getDialogMaterialTheme */.Z.getDialogMaterialTheme;
    //----------------SELECT INIT-------------------
    var options = [
        {
            label: "Destinations",
            options: [
                {
                    label: "Rethymno",
                    value: "Rethymno"
                },
                {
                    label: "Heraklion",
                    value: "Heraklion"
                }
            ]
        },
        {
            label: "Properties",
            options: [
                {
                    label: "Rethymno Villa 1",
                    value: "Rethymno Villa 1"
                },
                {
                    label: "Rethymno Villa 2",
                    value: "Rethymno Villa 2"
                }
            ]
        }, 
    ];
    var minBedrooms = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["minBedrooms"];
    });
    var maxBedrooms = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["maxBedrooms"];
    });
    var bedroomOptionsHandler = function() {
        var options = [
            {
                label: "All",
                value: 0
            }
        ];
        for(var i = minBedrooms; i <= maxBedrooms; i++){
            if (i > 0) {
                options.push({
                    label: i,
                    value: i
                });
            }
        }
        return options;
    };
    var bedroomOptions = bedroomOptionsHandler();
    //----------------SELECT CUSTOM STYLES-------------------
    var customStyles = {
        container: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                paddingTop: "20px",
                maxWidth: 350
            });
        },
        control: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                minHeight: "32px",
                border: "none",
                backgroundColor: "transparent!important",
                borderColor: "transparent!important",
                boxShadow: "none!important",
                fontSize: "14px"
            });
        },
        valueContainer: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                padding: "0 8px"
            });
        },
        menu: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                zIndex: "1000",
                borderRadius: props.searchbarRadius != null ? props.searchbarRadius + "px" : "10px"
            });
        },
        menuList: function(provided, state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                backgroundColor: state.isFocused ? "#f4f4f4" : state.isSelected ? "#f4f4f4" : state.isActive ? "#f4f4f4" : "transparent",
                background: state.isFocused ? "#f4f4f4" : state.isSelected ? "#f4f4f4" : state.isActive ? "#f4f4f4" : "transparent",
                margin: "8px 10px",
                letterSpacing: "0.01em",
                fontSize: "14px",
                fontFamily: '"Inter UI", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
            });
        },
        option: function(provided, state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                backgroundColor: state.isFocused ? "#f4f4f4" : state.isSelected ? "#f4f4f4" : state.isActive ? "#f4f4f4" : "transparent",
                background: state.isFocused ? "#f4f4f4" : state.isSelected ? "#f4f4f4" : state.isActive ? "#f4f4f4" : "transparent",
                color: "#4b4b4b",
                padding: "6px 13px",
                letterSpacing: "0.01em",
                fontFamily: '"Inter UI", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
            });
        },
        groupHeading: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                padding: "6px",
                fontWeight: "600",
                fontSize: "11px",
                color: "#000",
                letterSpacing: "0.01em",
                fontFamily: '"Inter UI", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
            });
        },
        input: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                margin: 0,
                padding: 0,
                color: props.hasOwnProperty("fullWidthBar") ? props.searchbarThemeColor != null ? !props.searchbarThemeColor ? "#fff" : "#000" : props.designMode ? "#fff" : "#000" : "#000"
            });
        },
        singleValue: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                color: props.hasOwnProperty("fullWidthBar") ? props.searchbarThemeColor != null ? !props.searchbarThemeColor ? "#fff" : "#000" : props.designMode ? "#fff" : "#000" : "#000"
            });
        },
        placeholder: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                color: props.hasOwnProperty("fullWidthBar") ? props.searchbarThemeColor != null ? !props.searchbarThemeColor ? "#fff" : "#000" : props.designMode ? "#fff" : "#000" : "#000",
                opacity: "0.7"
            });
        }
    };
    var textColor = "text-black";
    var borderColor = "b-transparent-black";
    var buttonColor = "b-transparent-black";
    if (props.searchbarThemeColor != null) if (!props.searchbarThemeColor) {
        textColor = "text-white";
        borderColor = "b-transparent-white";
        buttonColor = "b-transparent-white";
    } else {
        textColor = "text-black";
        borderColor = "b-transparent-black";
        buttonColor = "b-transparent-black";
    }
    else if (props.designMode) {
        textColor = "text-white";
        borderColor = "b-transparent-white";
        buttonColor = "b-transparent-white";
    } else {
        textColor = "text-black";
        borderColor = "b-transparent-black";
        buttonColor = "b-transparent-black";
    }
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([
        null,
        null
    ]), 2), value = ref[0], setValue = ref[1];
    //const setOpen = useState( false );
    //-------------POP OVER----------------
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), popover_anchorEl = ref1[0], popover_setAnchorEl = ref1[1];
    var popover_handleOpen = function(event) {
        popover_setAnchorEl(event.currentTarget);
        document.getElementById("guests_label").classList.add("fade");
        document.getElementById("guests_label").parentElement.classList.add("focused");
    };
    var popover_handleClose = function() {
        document.getElementById("guests_label").classList.remove("fade");
        document.getElementById("guests_label").parentElement.classList.remove("focused");
        popover_setAnchorEl(null);
    };
    var popover_open = Boolean(popover_anchorEl);
    var popover_id = popover_open ? "simple-popover" : undefined;
    var ref2 = (0,react.useState)(0), adults_amount = ref2[0], adults_setAmount = ref2[1];
    var ref3 = (0,react.useState)(0), kids_amount = ref3[0], kids_setAmount = ref3[1];
    var ref4 = (0,react.useState)(0), infants_amount = ref4[0], infants_setAmount = ref4[1];
    var ref5 = (0,react.useState)(true), adults_decreaseHidden = ref5[0], adults_setDecreaseHidden = ref5[1];
    var ref6 = (0,react.useState)(true), kids_decreaseHidden = ref6[0], kids_setDecreaseHidden = ref6[1];
    var ref7 = (0,react.useState)(true), infants_decreaseHidden = ref7[0], infants_setDecreaseHidden = ref7[1];
    var ref8 = (0,react.useState)(false), adults_increaseHidden = ref8[0], adults_setIncreaseHidden = ref8[1];
    var ref9 = (0,react.useState)(false), kids_increaseHidden = ref9[0], kids_setIncreaseHidden = ref9[1];
    var ref10 = (0,react.useState)(false), infants_increaseHidden = ref10[0], infants_setIncreaseHidden = ref10[1];
    var ref11 = (0,react.useState)("Who"), guests_text = ref11[0], guests_setText = ref11[1];
    var adults_handleIncrease = function() {
        adults_setAmount(function(adults_amount) {
            return adults_amount + 1;
        });
        if (adults_amount + 1 > 0) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        if (adults_amount + 1 < 30) adults_setIncreaseHidden(false);
        else adults_setIncreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(adults_amount + 1, kids_amount, infants_amount);
        });
    };
    var adults_handleDecrease = function() {
        adults_setAmount(function(adults_amount) {
            return adults_amount - 1;
        });
        if (adults_amount - 1 < 1) adults_setDecreaseHidden(true);
        else if ((kids_amount > 0 || infants_amount > 0) && adults_amount - 1 < 2) adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        if (adults_amount - 1 >= 0) adults_setIncreaseHidden(false);
        else adults_setIncreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(adults_amount - 1, kids_amount, infants_amount);
        });
    };
    var kids_handleIncrease = function() {
        kids_setAmount(function(kids_amount) {
            return kids_amount + 1;
        });
        if (kids_amount + 1 > 0) kids_setDecreaseHidden(false);
        else kids_setDecreaseHidden(true);
        if (kids_amount + 1 < 30) kids_setIncreaseHidden(false);
        else kids_setIncreaseHidden(true);
        if (adults_amount == 0) {
            adults_setAmount(function(adults_amount) {
                return adults_amount + 1;
            });
            adults_setDecreaseHidden(true);
            guests_setText(function() {
                return guestsTextCalc(adults_amount + 1, kids_amount + 1, infants_amount);
            });
        } else {
            guests_setText(function() {
                return guestsTextCalc(adults_amount, kids_amount + 1, infants_amount);
            });
            if (adults_amount < 2) adults_setDecreaseHidden(true);
            else adults_setDecreaseHidden(false);
        }
    };
    var kids_handleDecrease = function() {
        kids_setAmount(function(kids_amount) {
            return kids_amount - 1;
        });
        if (kids_amount - 1 < 1) kids_setDecreaseHidden(true);
        else kids_setDecreaseHidden(false);
        if (kids_amount - 1 >= 0) kids_setIncreaseHidden(false);
        else kids_setIncreaseHidden(true);
        if (adults_amount == 1) if (kids_amount - 1 < 1 && infants_amount < 1) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        guests_setText(function() {
            return guestsTextCalc(adults_amount, kids_amount - 1, infants_amount);
        });
    };
    var infants_handleIncrease = function() {
        infants_setAmount(function(infants_amount) {
            return infants_amount + 1;
        });
        if (infants_amount + 1 > 0) infants_setDecreaseHidden(false);
        else infants_setDecreaseHidden(true);
        if (infants_amount + 1 < 30) infants_setIncreaseHidden(false);
        else infants_setIncreaseHidden(true);
        if (adults_amount == 0) {
            adults_setAmount(function(prevState) {
                return prevState + 1;
            });
            adults_setDecreaseHidden(true);
            guests_setText(function() {
                return guestsTextCalc(adults_amount + 1, kids_amount, infants_amount + 1);
            });
        } else {
            guests_setText(function() {
                return guestsTextCalc(adults_amount, kids_amount, infants_amount + 1);
            });
            if (adults_amount < 2) adults_setDecreaseHidden(true);
            else adults_setDecreaseHidden(false);
        }
    };
    var infants_handleDecrease = function() {
        infants_setAmount(function(infants_amount) {
            return infants_amount - 1;
        });
        if (infants_amount - 1 < 1) infants_setDecreaseHidden(true);
        else infants_setDecreaseHidden(false);
        if (infants_amount - 1 >= 0) infants_setIncreaseHidden(false);
        else infants_setIncreaseHidden(true);
        if (adults_amount == 1) if (kids_amount < 1 && infants_amount - 1 < 1) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        guests_setText(function() {
            return guestsTextCalc(adults_amount, kids_amount, infants_amount - 1);
        });
    };
    //-------------DIALOG-------------
    var ref12 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), dialog_open = ref12[0], dialog_setOpen = ref12[1];
    // const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    var dialog_handleOpen = function() {
        dialog_setOpen(true);
    };
    var dialog_handleClose = function(value) {
        dialog_setOpen(false);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var setGuestsAmountZero = function() {
        dispatch((0,actions/* setAdults */.MJ)(0));
        dispatch((0,actions/* setKids */.ob)(0));
        dispatch((0,actions/* setInfants */.ZG)(0));
        adults_setAmount(0);
        kids_setAmount(0);
        infants_setAmount(0);
        adults_setDecreaseHidden(true);
        kids_setDecreaseHidden(true);
        infants_setDecreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(0, 0, 0);
        });
        dialog_handleClose("close");
    };
    var focusToggle = function(type) {
        if (document !== undefined) {
            var checkinById = document.getElementById("form-group-default-checkin");
            var checkoutById = document.getElementById("form-group-default-checkout");
            var checkin = document.querySelector(".form-group-default-checkin");
            var checkinLabel = document.querySelector("#checkin_label");
            var checkout = document.querySelector(".form-group-default-checkout");
            var checkoutLabel = document.querySelector("#checkout_label");
            switch(type){
                case "close_all":
                    checkin.classList.remove("focused");
                    checkinLabel.classList.remove("fade");
                    checkout.classList.remove("focused");
                    checkoutLabel.classList.remove("fade");
                    checkinById.blur();
                    checkoutById.blur();
                    break;
                case "close_checkin":
                    checkin.classList.remove("focused");
                    checkinLabel.classList.remove("fade");
                    checkout.classList.add("focused");
                    checkoutLabel.classList.add("fade");
                    checkinById.blur();
                    checkoutById.focus();
                    break;
                case "close_checkout":
                    checkin.classList.add("focused");
                    checkinLabel.classList.add("fade");
                    checkout.classList.remove("focused");
                    checkoutLabel.classList.remove("fade");
                    checkinById.focus();
                    checkoutById.blur();
                    break;
            }
        }
    };
    var disableWeekends = function(date) {
        return date.getDay() === 0 || date.getDay() === 6;
    };
    var disableAllDatesAfterTwoYears = function(date) {
        var value = null;
        if (Checkers/* default.objChildExists */.Z.objChildExists(props, "hasOpenCalendar") && !Checkers/* default.booleanState */.Z.booleanState(props.hasOpenCalendar)) {
            var thisDate = new Date();
            var disableAfter = new Date(thisDate.getFullYear() + 2, thisDate.getMonth(), thisDate.getDate());
            value = new Date(date.getFullYear(), date.getMonth(), date.getDate()) >= disableAfter;
        }
        return value;
    };
    var popover = {
        //-----POP_OVER Variables, Handlers-------
        adults: {
            handleIncrease: adults_handleIncrease,
            handleDecrease: adults_handleDecrease,
            decreaseHidden: adults_decreaseHidden,
            increaseHidden: adults_increaseHidden,
            setDecreaseHidden: adults_setDecreaseHidden,
            setIncreaseHidden: adults_setIncreaseHidden,
            setAmount: adults_setAmount,
            amount: adults_amount
        },
        kids: {
            handleIncrease: kids_handleIncrease,
            handleDecrease: kids_handleDecrease,
            decreaseHidden: kids_decreaseHidden,
            increaseHidden: kids_increaseHidden,
            setDecreaseHidden: kids_setDecreaseHidden,
            setIncreaseHidden: kids_setIncreaseHidden,
            setAmount: kids_setAmount,
            amount: kids_amount
        },
        infants: {
            handleIncrease: infants_handleIncrease,
            handleDecrease: infants_handleDecrease,
            decreaseHidden: infants_decreaseHidden,
            increaseHidden: infants_increaseHidden,
            setDecreaseHidden: infants_setDecreaseHidden,
            setIncreaseHidden: infants_setIncreaseHidden,
            setAmount: infants_setAmount,
            amount: infants_amount
        },
        setGuestsAmountZero: setGuestsAmountZero,
        guestsText: guests_text,
        guestsSetText: guests_setText,
        guestsTextCalc: guestsTextCalc,
        customTheme: popoverMaterialTheme,
        handleOpen: popover_handleOpen,
        handleClose: popover_handleClose,
        anchorEl: popover_anchorEl,
        open: popover_open,
        id: popover_id
    };
    var dialog = {
        handleClose: dialog_handleClose,
        handleOpen: dialog_handleOpen,
        setOpen: dialog_setOpen,
        open: dialog_open,
        customTheme: dialogMaterialTheme
    };
    var calendar = {
        value: value,
        setValue: setValue,
        customTheme: calendarMaterialTheme,
        focusToggle: focusToggle,
        disableWeekends: disableWeekends,
        disableAllDatesAfterTwoYears: disableAllDatesAfterTwoYears
    };
    var settings = {
        textColor: textColor,
        buttonColor: buttonColor,
        borderColor: borderColor,
        isManager: props.hasOwnProperty("isManager") ? props.isManager != null ? props.isManager : false : false,
        searchbarRadius: props.hasOwnProperty("searchbarRadius") ? props.searchbarRadius != null ? props.searchbarRadius : null : null,
        searchbarShadow: props.hasOwnProperty("searchbarShadow") ? props.searchbarShadow != null ? props.searchbarShadow : null : null,
        bookingSearchbarWithBedrooms: props.hasOwnProperty("bookingSearchbarWithBedrooms") ? props.bookingSearchbarWithBedrooms != null ? props.bookingSearchbarWithBedrooms : null : null,
        position: props.hasOwnProperty("position") ? props.position != null ? props.position : null : null,
        fixed: props.hasOwnProperty("position") ? !props.position ? "fixed-bottom" : "" : ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.hasOwnProperty("sliderSearchBar") ? props.sliderSearchBar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderContainedBar, {
            padding: Checkers/* default.objChildExists */.Z.objChildExists(props, "padding") ? props.padding : null,
            containerClass: Checkers/* default.objChildExists */.Z.objChildExists(props, "containerClass") ? props.containerClass : null,
            isManager: settings.isManager,
            textColor: settings.textColor,
            searchbarRadius: settings.searchbarRadius,
            searchbarShadow: settings.searchbarShadow,
            noShadow: Checkers/* default.objChildExists */.Z.objChildExists(props, "noShadow") && props.noShadow,
            bookingSearchbarWithBedrooms: settings.bookingSearchbarWithBedrooms,
            sliderSearchBarFullWidth: Checkers/* default.objChildExists */.Z.objChildExists(props, "sliderSearchBarFullWidth") ? props.sliderSearchBarFullWidth : false,
            //---SELECT----
            options: options,
            bedroomOptions: bedroomOptions,
            customStyles: customStyles,
            //---CALENDAR----
            calendar: calendar,
            //-----POP_OVER-------
            popover: popover,
            // DIALOG
            dialog: dialog,
            isHomePage: props.isHomepage,
            isHotel: props.isHotel,
            updateUri: updateUri
        }) : "" : props.hasOwnProperty("underSliderContained") ? props.underSliderContained ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UnderSliderContainedBar, {
            isManager: settings.isManager,
            textColor: settings.textColor,
            searchbarRadius: settings.searchbarRadius,
            searchbarShadow: settings.searchbarShadow,
            bookingSearchbarWithBedrooms: settings.bookingSearchbarWithBedrooms,
            //---SELECT----
            options: options,
            bedroomOptions: bedroomOptions,
            customStyles: customStyles,
            //---CALENDAR----
            calendar: calendar,
            //-----POP_OVER-------
            popover: popover,
            // DIALOG
            dialog: dialog,
            updateUri: updateUri
        }) : "" : props.hasOwnProperty("fullWidthBar") ? props.fullWidthBar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthBar/* default */.Z, {
            isManager: settings.isManager,
            textColor: settings.textColor,
            buttonColor: settings.buttonColor,
            borderColor: settings.borderColor,
            position: settings.position,
            bookingSearchbarWithBedrooms: settings.bookingSearchbarWithBedrooms,
            fixed: settings.fixed,
            //---SELECT----
            options: options,
            bedroomOptions: bedroomOptions,
            customStyles: customStyles,
            //---CALENDAR----
            calendar: calendar,
            //-----POP_OVER-------
            popover: popover,
            // DIALOG
            dialog: dialog,
            updateUri: updateUri
        }) : "" : ""
    });
}
function guestsTextCalc(adults_amount, kids_amount, infants_amount) {
    var guests_sum = adults_amount + kids_amount;
    if (guests_sum > 1 && infants_amount > 1) return guests_sum + " guests, " + infants_amount + " infants";
    else if (guests_sum > 1 && infants_amount == 1) return guests_sum + " guests, 1 infant";
    else if (guests_sum == 1 && infants_amount > 1) return "1 guest, " + infants_amount + " infants";
    else if (guests_sum == 1 && infants_amount == 1) return "1 guest, 1 infant";
    else if (guests_sum > 1) return guests_sum + " guests";
    else if (guests_sum == 1) return "1 guest";
    else return "Who will stay";
}


/***/ }),

/***/ 26575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FullWidthBar; },
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(4012);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31969);
/* harmony import */ var react_select_async_creatable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7398);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18256);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(87091);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96350);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(4271);
/* harmony import */ var _mui_material_Popover__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(97120);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(2753);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41690);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83974);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46093);
/* harmony import */ var _AppContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1860);
/* harmony import */ var _partials_CalendarCheckin__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65305);
/* harmony import */ var _partials_CalendarCheckout__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64239);
/* harmony import */ var _partials_Guests__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59207);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23158);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34357);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(72976);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(76112);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_15__);







// import Select from 'react-select';


















var Select = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1919));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1919)
            ];
        }
    },
    ssr: false
});
function getDefaultOptions(pageId) {
    return _getDefaultOptions.apply(this, arguments);
}
function _getDefaultOptions() {
    _getDefaultOptions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(pageId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_6___default().post("/apiloggia", {
                            action: "/api/lodge/frontend/get/search-suggestions/default?page_id=" + pageId,
                            useCache: false
                        }).then(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(response) {
                                var defaultLocationValue, options, data;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            options = [];
                                            data = response.data;
                                            return [
                                                4,
                                                data.forEach(function() {
                                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(suggestion) {
                                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        options.push({
                                                                            label: suggestion.title,
                                                                            value: suggestion.id,
                                                                            slug: suggestion.slug
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    if (suggestion.slug == window.location.pathname) {
                                                                        defaultLocationValue = {
                                                                            value: suggestion.id,
                                                                            label: suggestion.title,
                                                                            slug: suggestion.slug
                                                                        };
                                                                    }
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(suggestion) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }())
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2,
                                                {
                                                    options: options,
                                                    defaultLocationValue: defaultLocationValue
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(response) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _getDefaultOptions.apply(this, arguments);
}
function FullWidthBar(props) {
    var updateUri = props.hasOwnProperty("updateUri") ? props.updateUri : true;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    var currentDestination = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["currentDestination"];
    });
    var propertiesParams = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"];
    });
    var customSearch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["search"];
    });
    var pageId = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var destinations = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["destinations"];
    });
    var isListingPage = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["isListingPage"];
    });
    var isSearchPage = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["isSearchPage"];
    });
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_AppContext__WEBPACK_IMPORTED_MODULE_9__/* .page */ .M);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedLocation = ref[0], setSelectedLocation = ref[1];
    var searchSpinner = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["searchSpinner"];
    });
    var searchSelectLabel = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_13__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_select_label");
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), removeAllDestinations = ref1[0], setRemoveAllDestinations = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), localSearchText = ref2[0], setLocalSearchText = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), localDestinationId = ref3[0], setLocalDestinationId = ref3[1];
    var checkin = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        null,
        null
    ]), localDateRange = ref4[0], setLocalDateRange = ref4[1];
    var bedrooms = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["bedrooms"];
    });
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(bedrooms), localBedrooms = ref5[0], setLocalBedrooms = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), localAdultsNum = ref6[0], setLocalAdultsNum = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), localKidsNum = ref7[0], setLocalKidsNum = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), localInfantsNum = ref8[0], setLocalInfantsNum = ref8[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setLocalAdultsNum(propertiesParams.adults);
        setLocalKidsNum(propertiesParams.kids);
        setLocalInfantsNum(propertiesParams.infants);
    }, [
        propertiesParams
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var checkin_unix = new Date(checkin).valueOf() ? new Date(checkin) : null;
        var checkout_unix = new Date(checkout).valueOf() ? new Date(checkout) : null;
        setLocalDateRange([
            checkin_unix,
            checkout_unix
        ]);
    }, [
        checkin,
        checkout,
        propertiesParams
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setLocalBedrooms(bedrooms);
    }, [
        bedrooms,
        propertiesParams
    ]);
    var dateRangeHandler = function(val) {
        props.calendar.setValue(val);
        props.calendar.focusToggle("close_checkin");
        setLocalDateRange(val);
    };
    var handleInputChange = function(input) {
        var location_val = input.value;
        var location_data = location_val.split("_");
        var location_type = location_data[0];
        var location_id = location_data[1];
        if (location_type == "all") {
            setSelectedLocation(input);
            setRemoveAllDestinations(true);
            setLocalSearchText("");
        } else if (location_type == "destination") {
            setSelectedLocation(input);
            setRemoveAllDestinations(false);
            setLocalDestinationId(location_id);
            setLocalSearchText("");
        } else if (location_type != "property") {
            setSelectedLocation(input);
            setRemoveAllDestinations(true);
            setLocalSearchText(input.label);
        } else {
            var customOption = {
                value: input.label,
                label: input.label
            };
            setSelectedLocation(customOption);
            setRemoveAllDestinations(true);
            setLocalSearchText(input.label);
        }
    };
    var dispatchValues = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                if (removeAllDestinations) {
                    dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .removeAllDestination */ .EA)());
                } else if (localDestinationId != null) {
                    dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setDestination */ .M)(localDestinationId));
                }
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setSearchText */ .FD)(localSearchText));
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setDateRange */ .t5)(localDateRange));
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setBedrooms */ .ze)(localBedrooms));
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setAdults */ .MJ)(localAdultsNum));
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setKids */ .ob)(localKidsNum));
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setInfants */ .ZG)(localInfantsNum));
                return [
                    2,
                    true
                ];
            });
        });
        return function dispatchValues() {
            return _ref.apply(this, arguments);
        };
    }();
    var searchHandler = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(event) {
            var queryString, location_id, location_val, location_data, location_type, queryString1, newUrl, queryString2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatchValues()
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setOffset */ .nb)(0));
                        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setPageNumber */ .oW)(1));
                        propertiesParams.offset = 0;
                        propertiesParams.adults = localAdultsNum;
                        propertiesParams.kids = localKidsNum;
                        propertiesParams.infants = localInfantsNum;
                        propertiesParams.bedrooms = localBedrooms;
                        propertiesParams.search = localSearchText;
                        if (removeAllDestinations) {
                            propertiesParams.destinations = [];
                        } else if (localDestinationId != null) {
                            propertiesParams.destinations = [
                                localDestinationId
                            ];
                        }
                        if (localDateRange[0] != null) {
                            propertiesParams.checkin = dayjs__WEBPACK_IMPORTED_MODULE_15___default()(localDateRange[0]).format("YYYY-MM-DD");
                        } else {
                            propertiesParams.checkin = null;
                        }
                        if (localDateRange[1] != null) {
                            propertiesParams.checkout = dayjs__WEBPACK_IMPORTED_MODULE_15___default()(localDateRange[1]).format("YYYY-MM-DD");
                        } else {
                            propertiesParams.checkout = null;
                        }
                        if (selectedLocation == null && !isSearchPage) {
                            queryString = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].serialize */ .Z.serialize(propertiesParams);
                            router.push("/properties/search/?" + queryString);
                            event.preventDefault();
                            return [
                                2
                            ];
                        }
                        location_id = "";
                        location_val = "";
                        if (selectedLocation != null) {
                            location_val = selectedLocation.value;
                            location_data = location_val.split("_");
                            location_type = location_data[0];
                            location_id = location_data[1];
                        }
                        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setSearchSpinner */ .jo)(true));
                        if (isListingPage && currentDestination == propertiesParams.destinations[0] && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(location_id)) {
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setLoadingProperties */ .Po)(true));
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchPropertiesAction */ .SH)(propertiesParams));
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setApplyParams */ .DY)(1));
                        } else if (isSearchPage) {
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setLoadingProperties */ .Po)(true));
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchPropertiesAction */ .SH)(propertiesParams));
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setApplyParams */ .DY)(1));
                            queryString1 = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].serialize */ .Z.serialize(propertiesParams);
                            propertiesParams.search = location_val;
                            newUrl = "/properties/search/?" + queryString1;
                            if (updateUri) {
                                window.history.replaceState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, window.history.state), {
                                    as: newUrl,
                                    url: newUrl
                                }), "", newUrl);
                            }
                        } else {
                            queryString2 = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].serialize */ .Z.serialize(propertiesParams);
                            propertiesParams.search = location_val;
                            router.push("/properties/search/?" + queryString2);
                        }
                        event.preventDefault();
                        return [
                            2
                        ];
                }
            });
        });
        return function searchHandler(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var popoverText = [];
        var adults = localAdultsNum + localKidsNum;
        if (adults > 0) {
            popoverText.push(adults + " adults");
        }
        var infants = localInfantsNum;
        if (infants > 0) {
            popoverText.push(infants + " infants");
        }
        if (popoverText.length > 0) {
            props.popover.guestsSetText(popoverText.join(", "));
        } else {
            props.popover.guestsSetText("Who will stay");
        }
    }, [
        localAdultsNum,
        localKidsNum,
        localInfantsNum
    ]);
    var loadOptions = function(inputValue, callback) {
        axios__WEBPACK_IMPORTED_MODULE_6___default().post("/apiloggia", {
            action: "/api/lodge/frontend/get/search-suggestions/all?page_id=" + pageContext.pageId + "&search=" + encodeURIComponent(inputValue),
            useCache: false
        }).then(function(response) {
            var options = [];
            var data = response.data;
            data = data.filter(function(i) {
                return i.title.toLowerCase().includes(inputValue.toLowerCase());
            });
            data.forEach(function(suggestion) {
                options.push({
                    label: suggestion.title,
                    value: suggestion.id,
                    slug: suggestion.slug
                });
            });
            callback(options);
        });
    };
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), defaults = ref9[0], setDefaults = ref9[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getDefaultOptions(pageId).then(function(response) {
            setDefaults(response.options);
            var destination = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidArray */ .Z.isValidArray(destinations) ? destinations[0] : null;
            var destinationFlag = false;
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidArray */ .Z.isValidArray(response.options) && response.options.map(function(item) {
                if (item.value == "destination_" + destination) {
                    setSelectedLocation(item);
                    destinationFlag = true;
                }
            });
            if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidString */ .Z.isValidString(customSearch) && !destinationFlag) {
                var customOption = {
                    value: customSearch,
                    label: customSearch
                };
                setSelectedLocation(customOption);
            } else if (!destinationFlag) {
                var customOption1 = {
                    value: "all_properties",
                    label: "All properties"
                };
                setSelectedLocation(customOption1);
            } else if (destinationFlag) {
                setLocalDestinationId(destination);
            }
        });
    }, [
        destinations,
        propertiesParams
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "test-1 bg-design-color searchbar-bg-color " + props.fixed,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                id: "frm_book_2",
                onSubmit: function(event) {
                    return searchHandler(event);
                },
                className: "row justify-content-center full-width no-margin needs-validation padding-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: props.isManager == true ? "col-12 col-lg-10 d-flex flex-wrap no-padding" : "col-12 d-flex flex-wrap no-padding",
                        children: [
                            props.isManager == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 col-lg-4 pb-3 pb-lg-0 px-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "form-group form-group-default form-group-default-select2 bg-transparent no-margin no-arrow overflow-visible " + props.borderColor + " " + props.textColor,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            htmlFor: "location_property",
                                            className: "form-label " + props.textColor,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faMapMarkerAlt */ .FGq
                                                }),
                                                " ",
                                                _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidString */ .Z.isValidString(searchSelectLabel) ? searchSelectLabel : "Location/Property"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select_async_creatable__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            // onFocus={ (event) => {
                                            //   setSearchFieldIsFocused(true)
                                            // }}
                                            // onBlur={ (event) => {
                                            //   setSearchFieldIsFocused(false)
                                            // }}
                                            cacheOptions: false,
                                            defaultOptions: defaults,
                                            loadOptions: loadOptions,
                                            onChange: handleInputChange,
                                            value: selectedLocation,
                                            className: "SearchBar-Form__form-group-select",
                                            id: "location_property",
                                            name: "location_property",
                                            inputId: "location_property",
                                            instanceId: "location_property",
                                            formatCreateLabel: function(inputValue) {
                                                return "Search for " + inputValue;
                                            },
                                            isSearchable: true,
                                            options: props.options,
                                            styles: props.customStyles,
                                            placeholder: "Where are you going",
                                            blurInputOnSelect: true,
                                            menuPlacement: "bottom",
                                            components: {
                                                DropdownIndicator: function() {
                                                    return null;
                                                },
                                                IndicatorSeparator: function() {
                                                    return null;
                                                }
                                            }
                                        })
                                    ]
                                })
                            }) : "",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: props.isManager == true ? "col-6 col-lg-3 pb-3 pb-lg-0 px-2" : "col-6 col-lg-4 pb-3 pb-lg-0 px-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    id: "form-group-default-checkin",
                                    className: "form-group form-group-default form-group-default-checkin no-margin h-100 " + props.borderColor,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            id: "checkin_label",
                                            className: "form-label " + props.textColor,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faCalendar */ .fT7
                                                }),
                                                " Check in"
                                            ]
                                        }),
                                        props.hasOwnProperty("calendar") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_CalendarCheckin__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            dateRange: localDateRange,
                                            setDateRange: dateRangeHandler,
                                            customTheme: props.calendar.customTheme,
                                            focusToggle: props.calendar.focusToggle,
                                            disableAllDatesAfterTwoYears: props.calendar.disableAllDatesAfterTwoYears
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: props.isManager == true ? "col-6 col-lg-3 pb-3 pb-lg-0 px-2" : "col-6 col-lg-4 pb-3 pb-lg-0 px-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    id: "form-group-default-checkout",
                                    className: "form-group form-group-default form-group-default-checkout no-margin h-100 " + props.borderColor,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            id: "checkout_label",
                                            className: "form-label " + props.textColor,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faCalendar */ .fT7
                                                }),
                                                " Check out"
                                            ]
                                        }),
                                        props.hasOwnProperty("calendar") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_CalendarCheckout__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            dateRange: localDateRange,
                                            setDateRange: dateRangeHandler,
                                            customTheme: props.calendar.customTheme,
                                            focusToggle: props.calendar.focusToggle,
                                            disableAllDatesAfterTwoYears: props.calendar.disableAllDatesAfterTwoYears
                                        })
                                    ]
                                })
                            }),
                            props.bookingSearchbarWithBedrooms ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-12 col-lg-2 h-100 pb-3 pb-lg-0 px-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "overflow-visible form-group form-group-default form-group-default-select2 bg-transparent no-margin no-arrow " + props.borderColor + " " + props.textColor,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                htmlFor: "bedrooms-select",
                                                className: "test-1 form-label " + props.textColor,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                                        icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faBed */ .by_
                                                    }),
                                                    " Bedrooms"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Select, {
                                                name: "bedrooms-select",
                                                value: (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_13__/* .getBedroomValue */ .r$)(localBedrooms, props.bedroomOptions),
                                                inputId: "bedrooms",
                                                isSearchable: true,
                                                options: props.bedroomOptions,
                                                styles: props.customStyles,
                                                onChange: function(newValue) {
                                                    (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_13__/* .updateBedrooms */ .tC)(newValue, setLocalBedrooms);
                                                },
                                                // blurInputOnSelect
                                                components: {
                                                    DropdownIndicator: function() {
                                                        return null;
                                                    },
                                                    IndicatorSeparator: function() {
                                                        return null;
                                                    }
                                                }
                                            }, "bedrooms-select")
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-12 col-lg-2 pb-3 pb-lg-0 px-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "form-group form-group-default no-margin h-100 " + props.buttonColor,
                                        children: props.hasOwnProperty("popover") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                    id: "guests_label",
                                                    className: "form-label " + props.textColor,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                                            icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faUserFriends */ .r$M
                                                        }),
                                                        " Guests"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "w-100 fs-14 fw-normal no-margin text-truncate opacity-70 hidden-xs hidden-sm " + props.textColor,
                                                    onClick: props.popover.handleOpen,
                                                    "aria-describedby": props.popover.id,
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: props.popover.guestsText
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "w-100 fs-14 fw-normal no-margin text-truncate opacity-70 visible-xs visible-sm visible-md " + props.textColor,
                                                    onClick: props.dialog.handleOpen,
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: props.popover.guestsText
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_styles__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                    theme: props.popover.customTheme,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Popover__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                                                        className: "hidden-xs hidden-sm",
                                                        id: props.popover.id,
                                                        open: props.popover.open,
                                                        anchorEl: props.popover.anchorEl,
                                                        onClose: props.popover.handleClose,
                                                        anchorOrigin: {
                                                            vertical: props.position ? "bottom" : "top",
                                                            horizontal: "left"
                                                        },
                                                        transformOrigin: {
                                                            vertical: props.position ? "top" : "bottom",
                                                            horizontal: "left"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_Guests__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                            popover: props.popover,
                                                            dialog: props.dialog,
                                                            mobile: false,
                                                            dispatchValues: false,
                                                            adultsNum: localAdultsNum,
                                                            kidsNum: localKidsNum,
                                                            infantsNum: localInfantsNum,
                                                            setAdultsNum: setLocalAdultsNum,
                                                            setKidsNum: setLocalKidsNum,
                                                            setInfantsNum: setLocalInfantsNum
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_styles__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                    theme: props.dialog.customTheme,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                                        onClose: props.dialog.handleClose,
                                                        open: props.dialog.open,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_Guests__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                            popover: props.popover,
                                                            dialog: props.dialog,
                                                            mobile: true,
                                                            dispatchValues: false,
                                                            adultsNum: localAdultsNum,
                                                            kidsNum: localKidsNum,
                                                            infantsNum: localInfantsNum,
                                                            setAdultsNum: setLocalAdultsNum,
                                                            setKidsNum: setLocalKidsNum,
                                                            setInfantsNum: setLocalInfantsNum
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            props.isManager != true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 col-lg-2 px-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-100 form-group form-group-default no-margin no-padding " + props.buttonColor,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        form: "frm_book_2",
                                        className: "h-100 btn btn-primary bg-transparent no-border no-padding w-100 " + props.textColor,
                                        "aria-label": "Search",
                                        style: {
                                            minHeight: "52px!important"
                                        },
                                        type: "submit",
                                        children: "Search"
                                    })
                                })
                            }) : ""
                        ]
                    }),
                    props.isManager == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-12 col-lg-2 px-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-100 form-group form-group-default no-margin no-padding " + props.buttonColor,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                form: "frm_book_2",
                                className: "h-100 btn btn-primary bg-transparent no-border no-padding w-100 " + props.textColor,
                                "aria-label": "Search",
                                style: {
                                    minHeight: "52px!important"
                                },
                                type: "submit",
                                children: searchSpinner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                            icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_24__/* .faSpinner */ .LM3,
                                            spin: true,
                                            className: "m-l-5 m-auto"
                                        }),
                                        " Searching"
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Search"
                                })
                            })
                        })
                    }) : ""
                ]
            })
        })
    });
}


/***/ }),

/***/ 65305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CalendarCheckin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2753);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91255);
/* harmony import */ var _mui_x_date_pickers_pro__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8031);
/* harmony import */ var _mui_x_date_pickers_pro_AdapterDateFns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83796);
/* harmony import */ var _mui_x_date_pickers_pro_DesktopDateRangePicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10071);
/* harmony import */ var _mui_x_date_pickers_pro_MobileDateRangePicker__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41941);










function CalendarCheckin(props) {
    var theme = props.hasOwnProperty("customTheme") ? props.customTheme : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden-xs hidden-sm",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_pro__WEBPACK_IMPORTED_MODULE_2__/* .LocalizationProvider */ ._, {
                    dateAdapter: _mui_x_date_pickers_pro_AdapterDateFns__WEBPACK_IMPORTED_MODULE_3__/* .AdapterDateFns */ .H,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        theme: theme,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_pro_DesktopDateRangePicker__WEBPACK_IMPORTED_MODULE_5__/* .DesktopDateRangePicker */ .W, {
                            // onChange={dateHandler}
                            startText: "Add dates",
                            calendars: 1,
                            value: props.dateRange,
                            // value={value}
                            minDate: new Date(),
                            inputFormat: "dd/MM/yyyy",
                            // disableCloseOnSelect={false}
                            showDaysOutsideCurrentMonth: true,
                            // onChange={(newValue) => {
                            //     props.setValue(newValue);
                            //     props.focusToggle('close_checkin');
                            //     dispatch(setDateRange(newValue))
                            // }}
                            onChange: props.setDateRange,
                            onClose: function() {
                                props.focusToggle("close_all");
                            },
                            shouldDisableDate: props.disableAllDatesAfterTwoYears,
                            renderInput: function(startProps) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, startProps), {
                                        autoComplete: "off"
                                    }))
                                });
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "visible-xs visible-sm visible-md",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_pro__WEBPACK_IMPORTED_MODULE_2__/* .LocalizationProvider */ ._, {
                    dateAdapter: _mui_x_date_pickers_pro_AdapterDateFns__WEBPACK_IMPORTED_MODULE_3__/* .AdapterDateFns */ .H,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        theme: theme,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_pro_MobileDateRangePicker__WEBPACK_IMPORTED_MODULE_9__/* .MobileDateRangePicker */ .a, {
                            startText: "Add dates",
                            // clearable={true}
                            // clearText={'Clear'}
                            showToolbar: false,
                            // value={value}
                            value: props.dateRange,
                            minDate: new Date(),
                            inputFormat: "dd/MM/yyyy",
                            // disableCloseOnSelect={true}
                            showDaysOutsideCurrentMonth: true,
                            // onChange={(newValue) => {
                            //     props.setValue(newValue);
                            //     props.focusToggle('close_checkin');
                            //     dispatch(setDateRange(newValue))
                            // }}
                            onChange: props.setDateRange,
                            onClose: function() {
                                props.focusToggle("close_all");
                            },
                            shouldDisableDate: props.disableAllDatesAfterTwoYears,
                            renderInput: function(startProps) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, startProps), {
                                        autoComplete: "off"
                                    }))
                                });
                            }
                        })
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 64239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CalendarCheckout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2753);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91255);
/* harmony import */ var _mui_x_date_pickers_pro__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8031);
/* harmony import */ var _mui_x_date_pickers_pro_AdapterDateFns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83796);
/* harmony import */ var _mui_x_date_pickers_pro_DesktopDateRangePicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10071);
/* harmony import */ var _mui_x_date_pickers_pro_MobileDateRangePicker__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41941);










function CalendarCheckout(props) {
    var theme = props.hasOwnProperty("customTheme") ? props.customTheme : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden-xs hidden-sm",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_pro__WEBPACK_IMPORTED_MODULE_2__/* .LocalizationProvider */ ._, {
                    dateAdapter: _mui_x_date_pickers_pro_AdapterDateFns__WEBPACK_IMPORTED_MODULE_3__/* .AdapterDateFns */ .H,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        theme: theme,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_pro_DesktopDateRangePicker__WEBPACK_IMPORTED_MODULE_5__/* .DesktopDateRangePicker */ .W, {
                            endText: "Add dates",
                            calendars: 1,
                            value: props.dateRange,
                            minDate: new Date(),
                            inputFormat: "dd/MM/yyyy",
                            // toolbarFormat="yyyy-mm-dd"
                            showDaysOutsideCurrentMonth: true,
                            // onChange={( newValue ) => {
                            //   props.setValue( newValue );
                            //   props.focusToggle( 'close_checkout' );
                            //   dispatch( setDateRange( newValue ) )
                            // }}
                            onChange: props.setDateRange,
                            onClose: function() {
                                props.focusToggle("close_all");
                            },
                            shouldDisableDate: props.disableAllDatesAfterTwoYears,
                            renderInput: function(startProps, endProps) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, endProps), {
                                        autoComplete: "off"
                                    }))
                                });
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "visible-xs visible-sm visible-md",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_pro__WEBPACK_IMPORTED_MODULE_2__/* .LocalizationProvider */ ._, {
                    dateAdapter: _mui_x_date_pickers_pro_AdapterDateFns__WEBPACK_IMPORTED_MODULE_3__/* .AdapterDateFns */ .H,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        theme: theme,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_pro_MobileDateRangePicker__WEBPACK_IMPORTED_MODULE_9__/* .MobileDateRangePicker */ .a, {
                            endText: "Add dates",
                            // clearable={true}
                            // clearText={'Clear'}
                            showToolbar: false,
                            value: props.dateRange,
                            minDate: new Date(),
                            inputFormat: "dd/MM/yyyy",
                            // disableCloseOnSelect={true}
                            showDaysOutsideCurrentMonth: true,
                            // onChange={( newValue ) => {
                            //   props.setValue( newValue );
                            //   props.focusToggle( 'close_checkout' );
                            //   dispatch( setDateRange( newValue ) )
                            // }}
                            onChange: props.setDateRange,
                            onClose: function() {
                                props.focusToggle("close_all");
                            },
                            shouldDisableDate: props.disableAllDatesAfterTwoYears,
                            renderInput: function(startProps, endProps) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, endProps), {
                                        autoComplete: "off"
                                    }))
                                });
                            }
                        })
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 59207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Guests; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31969);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72976);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96350);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73645);
/* harmony import */ var _mui_material_Divider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11571);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83974);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46093);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23158);










function Guests(props) {
    var dispatchValues = props.hasOwnProperty("dispatchValues") ? props.dispatchValues : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.hasOwnProperty("adultsNum") ? props.adultsNum : 0), localAdultsNum = ref[0], setLocalAdultsNum = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.hasOwnProperty("kidsNum") ? props.kidsNum : 0), localKidsNum = ref1[0], setLocalKidsNum = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.hasOwnProperty("infantsNum") ? props.infantsNum : 0), localInfantsNum = ref2[0], setLocalInfantsNum = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setLocalAdultsNum(props.hasOwnProperty("adultsNum") ? props.adultsNum : 0);
        setLocalKidsNum(props.hasOwnProperty("kidsNum") ? props.kidsNum : 0);
        setLocalInfantsNum(props.hasOwnProperty("infantsNum") ? props.infantsNum : 0);
    }, [
        props.adultsNum
    ]);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var labelWeight = props.hasOwnProperty("labelWeight") ? props.labelWeight : "bold";
    var viewType = props.hasOwnProperty("viewType") ? props.viewType : false;
    var isDesktop = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isDesktop"];
    });
    var kidsProhibited = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["kidsProhibited"];
    });
    var bookingSearchbarWithBedrooms = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "bookingSearchbarWithBedrooms");
    });
    var kidsFieldLabel = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_bookings_kids_field_label");
    });
    var adultsFieldLabel = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_bookings_adults_field_label");
    });
    var hideInfantField = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_bookings_hide_infants_field") == 1 ? true : false;
    });
    var property_id = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["property_id"];
    });
    var propertiesParams = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"];
    });
    var bookingFormTriggered = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["bookingFormTriggered"];
    });
    var priceLoading = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["priceLoading"];
    });
    var capacityMax = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["capacityMax"];
    });
    var propertyInitialAvailability = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertyAvailability"]["initialAvailability"];
    });
    var adultsNum = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kidsNum = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["kids"];
    });
    var infantsNum = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["infants"];
    });
    var personsForBooking = dispatchValues ? adultsNum + kidsNum + infantsNum : localAdultsNum + localKidsNum + localInfantsNum;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var popoverText = [];
        var adults = dispatchValues ? parseInt(propertiesParams.adults) + parseInt(propertiesParams.kids) : localAdultsNum + localKidsNum;
        if (adults > 0) {
            popoverText.push(adults + " adults");
        }
        var infants = dispatchValues ? parseInt(propertiesParams.infants) : localInfantsNum;
        if (infants > 0) {
            popoverText.push(infants + " infants");
        }
        if (popoverText.length > 0) {
            props.popover.guestsSetText(popoverText.join(", "));
        } else {
            props.popover.guestsSetText("Who will stay");
        }
    }, [
        propertiesParams,
        localAdultsNum,
        localKidsNum,
        localInfantsNum
    ]);
    var decreaseAdultsHandler = function decreaseAdultsHandler() {
        if (dispatchValues) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .decreaseAdults */ .Wx)());
        } else if (props.setAdultsNum != undefined) {
            props.setAdultsNum(localAdultsNum - 1);
            setLocalAdultsNum(localAdultsNum - 1);
        }
    };
    var increaseAdultsHandler = function increaseAdultsHandler() {
        if (dispatchValues) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .increaseAdults */ .pd)());
        } else if (props.setAdultsNum != undefined) {
            props.setAdultsNum(localAdultsNum + 1);
            setLocalAdultsNum(localAdultsNum + 1);
        }
    };
    var decreaseKidsHandler = function decreaseKidsHandler() {
        if (dispatchValues) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .decreaseKids */ .HD)());
        } else if (props.setKidsNum != undefined) {
            props.setKidsNum(localKidsNum - 1);
            setLocalKidsNum(localKidsNum - 1);
        }
    };
    var increaseKidsHandler = function increaseKidsHandler() {
        if (dispatchValues) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .increaseKids */ .V2)());
        } else if (props.setKidsNum != undefined) {
            props.setKidsNum(localKidsNum + 1);
            setLocalKidsNum(localKidsNum + 1);
        }
    };
    var decreaseInfantsHandler = function decreaseInfantsHandler() {
        if (dispatchValues) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .decreaseInfants */ .fY)());
        } else if (props.setInfantsNum != undefined) {
            props.setInfantsNum(localInfantsNum - 1);
            setLocalInfantsNum(localInfantsNum - 1);
        }
    };
    var increaseInfantsHandler = function increaseInfantsHandler() {
        if (dispatchValues) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .increaseInfants */ .x3)());
        } else if (props.setAdultsNum != undefined) {
            props.setInfantsNum(localInfantsNum + 1);
            setLocalInfantsNum(localInfantsNum + 1);
        }
    };
    var decreaseBedroomsHandler = function decreaseBedroomsHandler() {
        if (dispatchValues) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .decreaseBedrooms */ .dV)());
        }
    };
    var increaseBedroomsHandler = function increaseBedroomsHandler() {
        if (dispatchValues) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .increaseBedrooms */ .Vi)());
        }
    };
    var dateRangeValid = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["dateRangeValid"];
    });
    var enableButtons = (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .enableBookingBtn */ .AE)(propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid);
    var hasError = function() {
        if (bookingFormTriggered && !enableButtons) {
            return true;
        }
        return false;
    };
    if (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObj */ .Z.isValidObj(props, "popover")) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "row w-100 padding-20 no-margin",
        style: {
            maxWidth: "350px"
        },
        children: [
            !bookingSearchbarWithBedrooms || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidNumber */ .Z.isValidNumber(property_id) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    viewType == "property" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-danger fs-12 p-0 " + (bookingFormTriggered && hasError() ? "visible" : "invisible"),
                        children: "Please select number of guests"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-12 d-flex justify-content-between pt-1 pb-3 px-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "d-flex flex-column",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        className: labelWeight + " fs-16",
                                        children: "Adults"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "hint-text semi-bold fs-12 no-margin",
                                        children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(adultsFieldLabel) ? adultsFieldLabel : "13 years old and over"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        className: labelWeight + " fs-16 hidden",
                                        children: "Ενήλικες"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "hint-text semi-bold fs-12 no-margin hidden",
                                        children: "Ηλικίας 13 ετών και άνω"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "d-flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: decreaseAdultsHandler,
                                        disabled: dispatchValues ? propertiesParams["adults"] == 0 : localAdultsNum == 0,
                                        className: "d-flex justify-content-center align-items-center btn-decrease bg-transparent text-master",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                            className: "fs-16 semi-bold",
                                            icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faMinus */ .Kl4,
                                            style: {
                                                fontSize: "20px"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "adults",
                                        type: "number",
                                        className: "guest-input border-0 text-center",
                                        pattern: "^-?[0-9]\\d*\\.?\\d*$",
                                        min: props.popover.kids.amount > 0 || props.popover.infants.amount > 0 ? "1" : "0",
                                        max: "30",
                                        readOnly: props.mobile,
                                        disabled: true,
                                        value: dispatchValues ? propertiesParams.adults : localAdultsNum,
                                        autoComplete: "off",
                                        style: {
                                            width: "30px",
                                            margin: "0 7px",
                                            fontSize: "16px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: increaseAdultsHandler,
                                        disabled: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(capacityMax) && personsForBooking >= capacityMax,
                                        className: "d-flex justify-content-center align-items-center btn-increase bg-transparent text-master",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                            className: "fs-16 semi-bold",
                                            icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faPlus */ .r8p,
                                            style: {
                                                fontSize: "20px"
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Divider__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].valueToBoolean */ .Z.valueToBoolean(kidsProhibited) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-12 d-flex justify-content-between py-3 px-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "d-flex flex-column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    className: labelWeight + " fs-16",
                                                    children: "Kids"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "hint-text semi-bold fs-12 no-margin",
                                                    children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(kidsFieldLabel) ? kidsFieldLabel : "Ages 2-12"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    className: labelWeight + " fs-16 hidden",
                                                    children: "Παιδιά"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "hint-text semi-bold fs-12 no-margin hidden",
                                                    children: "Ηλικίας 2-12"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "d-flex align-items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    onClick: decreaseKidsHandler,
                                                    disabled: dispatchValues ? propertiesParams.kids == 0 : localKidsNum == 0,
                                                    className: "d-flex justify-content-center align-items-center btn-decrease bg-transparent text-master",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                        className: "fs-16 semi-bold",
                                                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faMinus */ .Kl4,
                                                        style: {
                                                            fontSize: "20px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    id: "kids",
                                                    type: "number",
                                                    className: "guest-input border-0 text-center",
                                                    pattern: "^-?[0-9]\\d*\\.?\\d*$",
                                                    min: "0",
                                                    max: "30",
                                                    readOnly: props.mobile,
                                                    disabled: true,
                                                    value: dispatchValues ? propertiesParams.kids : localKidsNum,
                                                    autoComplete: "off",
                                                    style: {
                                                        width: "30px",
                                                        margin: "0 7px",
                                                        fontSize: "16px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    onClick: increaseKidsHandler,
                                                    disabled: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(property_id) && personsForBooking >= capacityMax,
                                                    className: "d-flex justify-content-center align-items-center btn-increase bg-transparent text-master",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                        className: "fs-16 semi-bold",
                                                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faPlus */ .r8p,
                                                        style: {
                                                            fontSize: "20px"
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: !hideInfantField ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Divider__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "col-12 d-flex justify-content-between pt-3 pb-3 pb-lg-1 px-2",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex flex-column",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                className: labelWeight + " fs-16",
                                                                children: "Infants"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "hint-text semi-bold fs-12 no-margin",
                                                                children: "under 2"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                className: labelWeight + " fs-16 hidden",
                                                                children: "Βρέφη"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "hint-text semi-bold fs-12 no-margin hidden",
                                                                children: "κάτω από 2"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                onClick: decreaseInfantsHandler,
                                                                disabled: dispatchValues ? propertiesParams.infants == 0 : localInfantsNum == 0,
                                                                className: "d-flex justify-content-center align-items-center btn-decrease bg-transparent text-master",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                                    className: "fs-16 semi-bold",
                                                                    icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faMinus */ .Kl4,
                                                                    style: {
                                                                        fontSize: "20px"
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                id: "infants",
                                                                type: "number",
                                                                className: "guest-input border-0 text-center",
                                                                pattern: "^-?[0-9]\\d*\\.?\\d*$",
                                                                min: "0",
                                                                max: "30",
                                                                readOnly: props.mobile,
                                                                disabled: true,
                                                                value: dispatchValues ? propertiesParams.infants : localInfantsNum,
                                                                autoComplete: "off",
                                                                style: {
                                                                    width: "30px",
                                                                    margin: "0 7px",
                                                                    fontSize: "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                onClick: increaseInfantsHandler,
                                                                disabled: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(property_id) && personsForBooking >= capacityMax,
                                                                className: "d-flex justify-content-center align-items-center btn-increase bg-transparent text-master",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                                    className: "fs-16 semi-bold",
                                                                    icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faPlus */ .r8p,
                                                                    style: {
                                                                        fontSize: "20px"
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-12 d-flex justify-content-between pt-3 pb-3 pb-lg-1 px-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "d-flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    className: labelWeight + " fs-16",
                                    children: "Bedrooms"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    className: labelWeight + " fs-16 hidden",
                                    children: "Βρέφη"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "hint-text semi-bold fs-12 no-margin hidden",
                                    children: "κάτω από 2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "d-flex align-items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: decreaseBedroomsHandler,
                                    className: "d-flex justify-content-center align-items-center btn-decrease bg-transparent text-master",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                        className: "fs-16 semi-bold",
                                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faMinus */ .Kl4,
                                        style: {
                                            fontSize: "20px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    id: "infants",
                                    type: "number",
                                    className: "guest-input border-0 text-center",
                                    pattern: "^-?[0-9]\\d*\\.?\\d*$",
                                    min: "0",
                                    max: "30",
                                    readOnly: props.mobile,
                                    disabled: true,
                                    value: propertiesParams.bedrooms,
                                    autoComplete: "off",
                                    style: {
                                        width: "30px",
                                        margin: "0 7px",
                                        fontSize: "16px"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: increaseBedroomsHandler,
                                    className: "d-flex justify-content-center align-items-center btn-increase bg-transparent text-master",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                        className: "fs-16 semi-bold",
                                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faPlus */ .r8p,
                                        style: {
                                            fontSize: "20px"
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-12 m-t-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row d-flex p-0 text-right justify-content-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            className: "col-auto btn-design-color btn btn-primary text-lowercase",
                            onClick: props.popover.handleClose,
                            children: "close"
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}


/***/ }),

/***/ 1079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ right_SwipeableDrawerFilters; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/prop-types/index.js
var prop_types = __webpack_require__(51039);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../shared/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(89889);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(21653);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/CssBaseline/CssBaseline.js
var CssBaseline = __webpack_require__(30575);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/colors/grey.js
var grey = __webpack_require__(84075);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(16260);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/SwipeableDrawer/SwipeableDrawer.js + 4 modules
var SwipeableDrawer = __webpack_require__(23832);
// EXTERNAL MODULE: ./components/templates/property/partials/bookings/DateRangeWrapper.tsx + 1 modules
var DateRangeWrapper = __webpack_require__(32890);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/templates/index/bookingSearchBar/partials/Guests.tsx
var Guests = __webpack_require__(59207);
// EXTERNAL MODULE: ./helpers/class/Popover.ts
var Popover = __webpack_require__(22019);
// EXTERNAL MODULE: ./helpers/class/Dialog.ts
var Dialog = __webpack_require__(42970);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(46093);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/async-creatable/dist/react-select.esm.js + 1 modules
var react_select_esm = __webpack_require__(7398);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(87091);
// EXTERNAL MODULE: ./components/templates/index/bookingSearchBar/FullWidthBar.tsx
var FullWidthBar = __webpack_require__(26575);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
;// CONCATENATED MODULE: ./helpers/StylesHelper.tsx


var customAsyncSelectStyles = {
    container: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            paddingTop: "20px",
            maxWidth: 350
        });
    },
    control: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            minHeight: "32px",
            border: "none",
            backgroundColor: "transparent!important",
            borderColor: "transparent!important",
            boxShadow: "none!important",
            fontSize: "14px"
        });
    },
    valueContainer: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            padding: "0 8px"
        });
    },
    menuList: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            backgroundColor: state.isFocused ? "#f4f4f4" : state.isSelected ? "#f4f4f4" : state.isActive ? "#f4f4f4" : "transparent",
            background: state.isFocused ? "#f4f4f4" : state.isSelected ? "#f4f4f4" : state.isActive ? "#f4f4f4" : "transparent",
            margin: "8px 10px",
            letterSpacing: "0.01em",
            fontSize: "14px",
            fontFamily: '"Inter UI", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
        });
    },
    option: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            backgroundColor: state.isFocused ? "#f4f4f4" : state.isSelected ? "#f4f4f4" : state.isActive ? "#f4f4f4" : "transparent",
            background: state.isFocused ? "#f4f4f4" : state.isSelected ? "#f4f4f4" : state.isActive ? "#f4f4f4" : "transparent",
            color: "#4b4b4b",
            padding: "6px 13px",
            letterSpacing: "0.01em",
            fontFamily: '"Inter UI", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
        });
    },
    groupHeading: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            padding: "6px",
            fontWeight: "600",
            fontSize: "11px",
            color: "#000",
            letterSpacing: "0.01em",
            fontFamily: '"Inter UI", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
        });
    },
    input: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            margin: 0,
            padding: 0
        });
    },
    placeholder: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            opacity: "0.7"
        });
    }
};

// EXTERNAL MODULE: ../../shared/node_modules/axios/index.js
var axios = __webpack_require__(41690);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/right/SwipeableDrawerFilters.tsx



























var drawerBleeding = 0;
var Root = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        height: "100%",
        backgroundColor: theme.palette.mode === "light" ? grey/* default.100 */.Z[100] : theme.palette.background.default
    };
});
var StyledBox = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.palette.mode === "light" ? "#fff" : grey/* default.800 */.Z[800]
    };
});
var Puller = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        width: 30,
        height: 6,
        backgroundColor: theme.palette.mode === "light" ? grey/* default.300 */.Z[300] : grey/* default.900 */.Z[900],
        borderRadius: 3,
        position: "absolute",
        top: 8,
        left: "calc(50% - 15px)"
    };
});
var MobileStickyBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8180).then(__webpack_require__.bind(__webpack_require__, 23483));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23483)
            ];
        }
    },
    ssr: false
});
function guestsTextCalc(adults_amount, kids_amount, infants_amount) {
    var guests_sum = adults_amount + kids_amount;
    if (guests_sum > 1 && infants_amount > 1) return guests_sum + " guests, " + infants_amount + " infants";
    else if (guests_sum > 1 && infants_amount == 1) return guests_sum + " guests, 1 infant";
    else if (guests_sum == 1 && infants_amount > 1) return "1 guest, " + infants_amount + " infants";
    else if (guests_sum == 1 && infants_amount == 1) return "1 guest, 1 infant";
    else if (guests_sum > 1) return guests_sum + " guests";
    else if (guests_sum == 1) return "1 guest";
    else return "Who";
}
function SwipeableDrawerFilters(props) {
    var popoverMaterialTheme = Popover/* default.getPopoverMaterialTheme */.Z.getPopoverMaterialTheme;
    var dialogMaterialTheme = Dialog/* default.getDialogMaterialTheme */.Z.getDialogMaterialTheme;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), popover_anchorEl = ref[0], popover_setAnchorEl = ref[1];
    var popover_handleOpen = function(event1) {
        popover_setAnchorEl(event1.currentTarget);
        document.getElementById("guests_label").classList.add("fade");
        document.getElementById("guests_label").parentElement.classList.add("focused");
    };
    var popover_handleClose = function() {
        document.getElementById("guests_label").classList.remove("fade");
        document.getElementById("guests_label").parentElement.classList.remove("focused");
        popover_setAnchorEl(null);
    };
    var popover_open = Boolean(popover_anchorEl);
    var popover_id = popover_open ? "simple-popover" : undefined;
    var ref1 = (0,react.useState)(0), adults_amount = ref1[0], adults_setAmount = ref1[1];
    var ref2 = (0,react.useState)(0), kids_amount = ref2[0], kids_setAmount = ref2[1];
    var ref3 = (0,react.useState)(0), infants_amount = ref3[0], infants_setAmount = ref3[1];
    var ref4 = (0,react.useState)(true), adults_decreaseHidden = ref4[0], adults_setDecreaseHidden = ref4[1];
    var ref5 = (0,react.useState)(true), kids_decreaseHidden = ref5[0], kids_setDecreaseHidden = ref5[1];
    var ref6 = (0,react.useState)(true), infants_decreaseHidden = ref6[0], infants_setDecreaseHidden = ref6[1];
    var ref7 = (0,react.useState)(false), adults_increaseHidden = ref7[0], adults_setIncreaseHidden = ref7[1];
    var ref8 = (0,react.useState)(false), kids_increaseHidden = ref8[0], kids_setIncreaseHidden = ref8[1];
    var ref9 = (0,react.useState)(false), infants_increaseHidden = ref9[0], infants_setIncreaseHidden = ref9[1];
    var ref10 = (0,react.useState)("Who"), guests_text = ref10[0], guests_setText = ref10[1];
    var adults_handleIncrease = function() {
        adults_setAmount(function(adults_amount) {
            return adults_amount + 1;
        });
        if (adults_amount + 1 > 0) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        if (adults_amount + 1 < 30) adults_setIncreaseHidden(false);
        else adults_setIncreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(adults_amount + 1, kids_amount, infants_amount);
        });
    };
    var adults_handleDecrease = function() {
        adults_setAmount(function(adults_amount) {
            return adults_amount - 1;
        });
        if (adults_amount - 1 < 1) adults_setDecreaseHidden(true);
        else if ((kids_amount > 0 || infants_amount > 0) && adults_amount - 1 < 2) adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        if (adults_amount - 1 >= 0) adults_setIncreaseHidden(false);
        else adults_setIncreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(adults_amount - 1, kids_amount, infants_amount);
        });
    };
    var kids_handleIncrease = function() {
        kids_setAmount(function(kids_amount) {
            return kids_amount + 1;
        });
        if (kids_amount + 1 > 0) kids_setDecreaseHidden(false);
        else kids_setDecreaseHidden(true);
        if (kids_amount + 1 < 30) kids_setIncreaseHidden(false);
        else kids_setIncreaseHidden(true);
        if (adults_amount == 0) {
            adults_setAmount(function(adults_amount) {
                return adults_amount + 1;
            });
            adults_setDecreaseHidden(true);
            guests_setText(function() {
                return guestsTextCalc(adults_amount + 1, kids_amount + 1, infants_amount);
            });
        } else {
            guests_setText(function() {
                return guestsTextCalc(adults_amount, kids_amount + 1, infants_amount);
            });
            if (adults_amount < 2) adults_setDecreaseHidden(true);
            else adults_setDecreaseHidden(false);
        }
    };
    var kids_handleDecrease = function() {
        kids_setAmount(function(kids_amount) {
            return kids_amount - 1;
        });
        if (kids_amount - 1 < 1) kids_setDecreaseHidden(true);
        else kids_setDecreaseHidden(false);
        if (kids_amount - 1 >= 0) kids_setIncreaseHidden(false);
        else kids_setIncreaseHidden(true);
        if (adults_amount == 1) if (kids_amount - 1 < 1 && infants_amount < 1) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        guests_setText(function() {
            return guestsTextCalc(adults_amount, kids_amount - 1, infants_amount);
        });
    };
    var infants_handleIncrease = function() {
        infants_setAmount(function(infants_amount) {
            return infants_amount + 1;
        });
        if (infants_amount + 1 > 0) infants_setDecreaseHidden(false);
        else infants_setDecreaseHidden(true);
        if (infants_amount + 1 < 30) infants_setIncreaseHidden(false);
        else infants_setIncreaseHidden(true);
        if (adults_amount == 0) {
            adults_setAmount(function(prevState) {
                return prevState + 1;
            });
            adults_setDecreaseHidden(true);
            guests_setText(function() {
                return guestsTextCalc(adults_amount + 1, kids_amount, infants_amount + 1);
            });
        } else {
            guests_setText(function() {
                return guestsTextCalc(adults_amount, kids_amount, infants_amount + 1);
            });
            if (adults_amount < 2) adults_setDecreaseHidden(true);
            else adults_setDecreaseHidden(false);
        }
    };
    var infants_handleDecrease = function() {
        infants_setAmount(function(infants_amount) {
            return infants_amount - 1;
        });
        if (infants_amount - 1 < 1) infants_setDecreaseHidden(true);
        else infants_setDecreaseHidden(false);
        if (infants_amount - 1 >= 0) infants_setIncreaseHidden(false);
        else infants_setIncreaseHidden(true);
        if (adults_amount == 1) if (kids_amount < 1 && infants_amount - 1 < 1) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        guests_setText(function() {
            return guestsTextCalc(adults_amount, kids_amount, infants_amount - 1);
        });
    };
    //-------------DIALOG-------------
    var ref11 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), dialog_open = ref11[0], dialog_setOpen = ref11[1];
    // const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    var dialog_handleOpen = function() {
        dialog_setOpen(true);
    };
    var dialog_handleClose = function(value) {
        dialog_setOpen(false);
    };
    var setGuestsAmountZero = function() {
        dispatch((0,actions/* setAdults */.MJ)(0));
        dispatch((0,actions/* setKids */.ob)(0));
        dispatch((0,actions/* setInfants */.ZG)(0));
        dispatch((0,actions/* setBedrooms */.ze)(0));
        dispatch((0,actions/* setCheckin */.Rp)(null));
        dispatch((0,actions/* setCheckout */.k1)(null));
        adults_setAmount(0);
        kids_setAmount(0);
        infants_setAmount(0);
        adults_setDecreaseHidden(true);
        kids_setDecreaseHidden(true);
        infants_setDecreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(0, 0, 0);
        });
        dialog_handleClose("close");
    };
    var popover = {
        //-----POP_OVER Variables, Handlers-------
        adults: {
            handleIncrease: adults_handleIncrease,
            handleDecrease: adults_handleDecrease,
            decreaseHidden: adults_decreaseHidden,
            increaseHidden: adults_increaseHidden,
            setDecreaseHidden: adults_setDecreaseHidden,
            setIncreaseHidden: adults_setIncreaseHidden,
            setAmount: adults_setAmount,
            amount: adults_amount
        },
        kids: {
            handleIncrease: kids_handleIncrease,
            handleDecrease: kids_handleDecrease,
            decreaseHidden: kids_decreaseHidden,
            increaseHidden: kids_increaseHidden,
            setDecreaseHidden: kids_setDecreaseHidden,
            setIncreaseHidden: kids_setIncreaseHidden,
            setAmount: kids_setAmount,
            amount: kids_amount
        },
        infants: {
            handleIncrease: infants_handleIncrease,
            handleDecrease: infants_handleDecrease,
            decreaseHidden: infants_decreaseHidden,
            increaseHidden: infants_increaseHidden,
            setDecreaseHidden: infants_setDecreaseHidden,
            setIncreaseHidden: infants_setIncreaseHidden,
            setAmount: infants_setAmount,
            amount: infants_amount
        },
        setGuestsAmountZero: setGuestsAmountZero,
        guestsText: guests_text,
        guestsSetText: guests_setText,
        guestsTextCalc: guestsTextCalc,
        customTheme: popoverMaterialTheme,
        handleOpen: popover_handleOpen,
        handleClose: popover_handleClose,
        anchorEl: popover_anchorEl,
        open: popover_open,
        id: popover_id
    };
    var dialog = {
        handleClose: dialog_handleClose,
        handleOpen: dialog_handleOpen,
        setOpen: dialog_setOpen,
        open: dialog_open,
        customTheme: dialogMaterialTheme
    };
    var isMobile = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    var window = props.window;
    var ref12 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), open = ref12[0], setOpen = ref12[1];
    var toggleDrawer = function(newOpen) {
        return function() {
            setOpen(newOpen);
        };
    };
    var toggleDrawerV2 = function(newOpen) {
        setOpen(newOpen);
    };
    var container = window !== undefined ? function() {
        return window().document.body;
    } : undefined;
    var dispatch = (0,es/* useDispatch */.I0)();
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    var uiSearchBarDivHeight = (0,es/* useSelector */.v9)(function(state) {
        return state["uiData"]["searchBarDivHeight"];
    });
    var showSearchInput = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_search_in_mobile_panel");
    });
    var isListingPage = props.hasOwnProperty("forHomepage") ? !props.forHomepage : false;
    var searchProperties = function() {
        dispatch((0,actions/* setSearchSpinner */.jo)(true));
        if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(showSearchInput)) {
            searchHandler();
            return;
        }
        if (props.forHomepage != undefined && props.forHomepage) {
            var queryString = Checkers/* default.serialize */.Z.serialize(propertiesParams);
            router.push("/properties/search/?" + queryString);
            event.preventDefault();
        } else {
            searchHandler();
        // dispatch(setOffset(0))
        // dispatch(setPageNumber(1))
        // dispatch<any>(fetchPropertiesAction(propertiesParams, 0, uiSearchBarDivHeight))
        }
    };
    var router = (0,next_router.useRouter)();
    var searchHandler = function() {
        var event1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        dispatch((0,actions/* setOffset */.nb)(0));
        dispatch((0,actions/* setPageNumber */.oW)(1));
        propertiesParams.offset = 0;
        if (selectedLocation == null) {
            var queryString = Checkers/* default.serialize */.Z.serialize(propertiesParams);
            router.push("/properties/search/?" + queryString);
            if (event1 != null) {
                event1.preventDefault();
            }
            return;
        }
        var location_val = selectedLocation.value;
        var location_data = location_val.split("_");
        var location_type = location_data[0];
        var location_id = location_data[1];
        if (isListingPage && location_id == propertiesParams.destinations[0]) {
            dispatch((0,actions/* setLoadingProperties */.Po)(true));
            dispatch((0,actions/* fetchPropertiesAction */.SH)(propertiesParams));
            dispatch((0,actions/* setApplyParams */.DY)(1));
        } else {
            var queryString1 = Checkers/* default.serialize */.Z.serialize(propertiesParams);
            switch(location_type){
                case "destination":
                    router.push("/" + selectedLocation.slug + "?" + queryString1);
                    break;
                case "location":
                    router.push("/" + selectedLocation.slug + "?" + queryString1);
                    break;
                default:
                    propertiesParams.search = location_val;
                    queryString1 = Checkers/* default.serialize */.Z.serialize(propertiesParams);
                    router.push("/properties/search/?" + queryString1);
                    break;
            }
        }
        if (event1 != null) {
            event1.preventDefault();
        }
    };
    var ref13 = (0,react.useState)(null), selectedLocation = ref13[0], setSelectedLocation = ref13[1];
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var destinations = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["destinations"];
    });
    var customSearch = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["search"];
    });
    var ref14 = (0,react.useState)(null), defaults = ref14[0], setDefaults = ref14[1];
    var options = [
        {
            label: "Destinations",
            options: [
                {
                    label: "Rethymno",
                    value: "Rethymno"
                },
                {
                    label: "Heraklion",
                    value: "Heraklion"
                }
            ]
        },
        {
            label: "Properties",
            options: [
                {
                    label: "Rethymno Villa 1",
                    value: "Rethymno Villa 1"
                },
                {
                    label: "Rethymno Villa 2",
                    value: "Rethymno Villa 2"
                }
            ]
        }, 
    ];
    var loadOptions = function(inputValue, callback) {
        axios_default().post("/apiloggia", {
            action: "/api/lodge/frontend/get/search-suggestions/all?page_id=" + pageId + "&search=" + encodeURIComponent(inputValue),
            useCache: false
        }).then(function(response) {
            var options = [];
            var data = response.data;
            data = data.filter(function(i) {
                return i.title.toLowerCase().includes(inputValue.toLowerCase());
            });
            data.forEach(function(suggestion) {
                options.push({
                    label: suggestion.title,
                    value: suggestion.id,
                    slug: suggestion.slug
                });
            });
            callback(options);
        });
    };
    (0,react.useEffect)(function() {
        if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(showSearchInput)) {
            (0,FullWidthBar/* getDefaultOptions */.j)(pageId).then(function(response) {
                setDefaults(response.options);
                var destination = Checkers/* default.isValidArray */.Z.isValidArray(destinations) ? destinations[0] : null;
                Checkers/* default.isValidArray */.Z.isValidArray(response.options) && response.options.map(function(item) {
                    if (item.value == "destination_" + destination) {
                        setSelectedLocation(item);
                    }
                });
                if (customSearch != null) {
                    var customOption = {
                        value: customSearch,
                        label: customSearch
                    };
                    setSelectedLocation(customOption);
                }
            });
        }
    }, []);
    var handleInputChange = function(input) {
        var location_val = input.value;
        var location_data = location_val.split("_");
        var location_type = location_data[0];
        var location_id = location_data[1];
        if (location_type != "property") {
            setSelectedLocation(input);
            dispatch((0,actions/* setSearchText */.FD)(input.label));
        } else {
            var customOption = {
                value: input.label,
                label: input.label
            };
            setSelectedLocation(customOption);
            dispatch((0,actions/* setSearchText */.FD)(input.label));
        }
    };
    var searchSelectLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_select_label");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileStickyBar, {
                    forList: true,
                    toggleDrawer: toggleDrawerV2,
                    drawerOpened: open,
                    searchProperties: searchProperties,
                    setGuestsAmountZero: setGuestsAmountZero
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline/* default */.ZP, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(emotion_react_browser_esm/* Global */.xB, {
                            styles: {
                                ".MuiDrawer-root > .MuiPaper-root": {
                                    height: "calc(90% - ".concat(drawerBleeding, "px)"),
                                    overflow: "visible",
                                    borderTopLeftRadius: "8px",
                                    borderTopRightRadius: "8px"
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeableDrawer/* default */.Z, {
                            sx: {
                                zIndex: "1200",
                                position: "relative"
                            },
                            container: container,
                            anchor: "bottom",
                            open: open,
                            onClose: toggleDrawer(false),
                            onOpen: toggleDrawer(true),
                            swipeAreaWidth: drawerBleeding,
                            disableSwipeToOpen: false,
                            disableBackdropTransition: false,
                            ModalProps: {
                                keepMounted: false
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBox, {
                                // style={{marginTop: "40px"}}
                                sx: {
                                    px: 2,
                                    pb: 2,
                                    // height: '100%',
                                    overflow: "auto",
                                    borderTopRightRadius: "4px",
                                    borderTopLeftRadius: "4px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Puller, {
                                        onClick: toggleDrawer(!open)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            marginTop: "40px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row align-center overflow-scroll",
                                            style: {
                                                marginBottom: "80px"
                                            },
                                            children: [
                                                Checkers/* default.valueToBoolean */.Z.valueToBoolean(showSearchInput) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-lg-4 px-2 m-auto p-0",
                                                    style: {
                                                        maxWidth: "350px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "form-group form-group-default form-group-default-select2 bg-transparent no-margin no-arrow overflow-visible",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                htmlFor: "location_property",
                                                                className: "form-label ",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        icon: pro_regular_svg_icons/* faMapMarkerAlt */.FGq
                                                                    }),
                                                                    " ",
                                                                    Checkers/* default.isValidString */.Z.isValidString(searchSelectLabel) ? searchSelectLabel : "Location/Property"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.Z, {
                                                                cacheOptions: false,
                                                                defaultOptions: defaults,
                                                                loadOptions: loadOptions,
                                                                onChange: handleInputChange,
                                                                value: selectedLocation,
                                                                className: "SearchBar-Form__form-group-select",
                                                                id: "location_property",
                                                                name: "location_property",
                                                                inputId: "location_property",
                                                                instanceId: "location_property",
                                                                isSearchable: true,
                                                                options: options,
                                                                styles: customAsyncSelectStyles,
                                                                placeholder: "Where are you going",
                                                                blurInputOnSelect: true,
                                                                menuPlacement: "bottom",
                                                                formatCreateLabel: function(inputValue) {
                                                                    return "Search for " + inputValue;
                                                                },
                                                                components: {
                                                                    DropdownIndicator: function() {
                                                                        return null;
                                                                    },
                                                                    IndicatorSeparator: function() {
                                                                        return null;
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 align-center d-flex justify-content-center p-b-0 p-t-10",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "row w-100 no-padding no-margin",
                                                        style: {
                                                            maxWidth: "350px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeWrapper/* default */.Z, {
                                                            forList: true,
                                                            theme: props.calendar.customTheme,
                                                            isStatic: 1,
                                                            toggleDrawer: toggleDrawerV2,
                                                            containerClass: "p-0 border-bottom"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 align-center d-flex justify-content-center p-b-80",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Guests/* default */.Z, {
                                                        popover: popover,
                                                        dialog: dialog,
                                                        mobile: false,
                                                        labelWeight: ""
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}
SwipeableDrawerFilters.propTypes = {
    window: (prop_types_default()).func
};
/* harmony default export */ var right_SwipeableDrawerFilters = (SwipeableDrawerFilters);


/***/ }),

/***/ 32890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DateRangeWrapper; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/node_modules/@mui/x-date-pickers/AdapterDayjs/index.js + 1 modules
var AdapterDayjs = __webpack_require__(64828);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js + 2 modules
var ThemeProvider = __webpack_require__(2753);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(8031);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/DateRangePicker/DateRangePicker.js + 1 modules
var DateRangePicker = __webpack_require__(18819);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/StaticDateRangePicker/StaticDateRangePicker.js + 2 modules
var StaticDateRangePicker = __webpack_require__(21713);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ../../shared/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(76112);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(46093);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(87091);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/TextField/TextField.js + 40 modules
var TextField = __webpack_require__(91255);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/DateRangePickerDay/DateRangePickerDay.js + 1 modules
var DateRangePickerDay = __webpack_require__(30992);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(92596);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(31009);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/right/CustomDateRangePickerDay.tsx








function CustomDateRangePickerDay(param) {
    var pickersDayProps = param.pickersDayProps, toolTipHandler = param.toolTipHandler, datePickerClassHandler = param.datePickerClassHandler;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), tooltipIsOpen = ref[0], setTooltipIsOpen = ref[1];
    var isMobile = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
        onClickAway: function() {
            return setTooltipIsOpen(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            placement: "top",
            title: toolTipHandler(pickersDayProps.day),
            open: tooltipIsOpen,
            onClick: function() {
                return setTooltipIsOpen(true);
            },
            componentsProps: {
                tooltip: {
                    sx: {
                        backgroundColor: "#fff",
                        color: "#000",
                        boxShadow: "0px 0px 2px #000"
                    }
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "DateRangePickerDay-Wrapper " + datePickerClassHandler(pickersDayProps.day),
                style: {
                    borderTopLeftRadius: pickersDayProps.isStartOfHighlighting ? "50%" : "",
                    borderBottomLeftRadius: pickersDayProps.isStartOfHighlighting ? "50%" : "",
                    borderTopRightRadius: pickersDayProps.isEndOfHighlighting ? "50%" : "",
                    borderBottomRightRadius: pickersDayProps.isEndOfHighlighting ? "50%" : "",
                    background: pickersDayProps.isHighlighting ? "rgba(93,137,179, 0.5)" : ""
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangePickerDay/* DateRangePickerDay */.w, (0,_object_spread/* default */.Z)({}, pickersDayProps))
            })
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(27577);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(73645);
// EXTERNAL MODULE: ./helpers/LgConsts.tsx
var LgConsts = __webpack_require__(75082);
;// CONCATENATED MODULE: ./components/templates/property/partials/bookings/DateRangeWrapper.tsx




















function DateRangeWrapper(props) {
    var containerClass = props.hasOwnProperty("containerClass") ? props.containerClass : "pe-1";
    var dispatch = (0,es/* useDispatch */.I0)();
    var checkin = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var propertyAvailability = (0,es/* useSelector */.v9)(function(state) {
        return state["propertyAvailability"];
    });
    var isOpenCalendar = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isOpenCalendar"];
    });
    var ref = (0,react.useState)(false), openState = ref[0], setOpenState = ref[1];
    var value = (0,es/* useSelector */.v9)(function(state) {
        return [
            Checkers/* default.isValidDate */.Z.isValidDate(state["propertiesParams"]["checkin"]) ? dayjs_min_default()(state["propertiesParams"]["checkin"]) : null,
            Checkers/* default.isValidDate */.Z.isValidDate(state["propertiesParams"]["checkout"]) ? dayjs_min_default()(state["propertiesParams"]["checkout"]) : null
        ];
    });
    var datePickerMode = function() {
        var mode = "";
        if (checkin == "Invalid Date" && checkout == "Invalid Date") {
            mode = LgConsts/* default.datePickerModeForCheckin */.Z.datePickerModeForCheckin;
        } else if (checkin == null && checkout == null) {
            mode = LgConsts/* default.datePickerModeForCheckin */.Z.datePickerModeForCheckin;
        } else if (Checkers/* default.isValidDate */.Z.isValidDate(checkin) && Checkers/* default.isValidDate */.Z.isValidDate(checkout)) {
            mode = LgConsts/* default.datePickerModeResetRange */.Z.datePickerModeResetRange;
        } else if (Checkers/* default.isValidDate */.Z.isValidDate(checkin) && !Checkers/* default.isValidDate */.Z.isValidDate(checkout)) {
            mode = LgConsts/* default.datePickerModeForCheckout */.Z.datePickerModeForCheckout;
        }
        return mode;
    };
    var twoYearsAvailabilty = propertyAvailability.checkin != null && propertyAvailability.checkin.result != undefined ? propertyAvailability.checkin.result[0].availability.availability : null;
    var twoYearsAvailabiltyCheckout = propertyAvailability.checkout != null && propertyAvailability.checkout.result != undefined ? propertyAvailability.checkout.result[0].availability.availability : null;
    var minStayToCheck = twoYearsAvailabilty != null && Checkers/* default.isValidDate */.Z.isValidDate(checkin) && twoYearsAvailabilty[checkin] != undefined ? twoYearsAvailabilty[checkin]["min_stay"] : null;
    var bookingMaxInAdvance = propertyAvailability.checkin != null && propertyAvailability.checkin.result != undefined ? propertyAvailability.checkin.bookingMaxInAdvance : null;
    var ref1 = (0,react.useState)(null), dateRangeForCheckout = ref1[0], setDateRangeForCheckout = ref1[1];
    var dateRangeForCheckoutHandler = function() {
        if (props.forList) {
            // let diffFromToday = Math.abs(checkin.diff(checkout.format('YYYY-MM-DD'), 'day'))
            var checkinObject = dayjs_min_default()(checkin);
            var checkoutObject = dayjs_min_default()(checkout);
            if (checkinObject > checkoutObject) {
                dispatch((0,actions/* setDateRange */.t5)([
                    checkoutObject,
                    null
                ]));
            }
            return false;
        }
        if (datePickerMode() == LgConsts/* default.datePickerModeForCheckout */.Z.datePickerModeForCheckout) {
            var newDateRange = {};
            var checkinDateObject = new Date(checkin);
            var availabilityFlag = 0;
            var counter = 0;
            Object.keys(twoYearsAvailabiltyCheckout).forEach(function(key, index, item) {
                var theDateToCheck = new Date(twoYearsAvailabiltyCheckout[key]["date"]);
                var theDateToCheckAvailability = twoYearsAvailabiltyCheckout[key]["status"];
                if (theDateToCheck > checkinDateObject) {
                    counter++;
                    if (counter == minStayToCheck && availabilityFlag == 0) {
                        availabilityFlag = 1;
                    }
                    if (availabilityFlag == 1) {
                        if (theDateToCheckAvailability != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                            availabilityFlag = 2;
                        }
                        newDateRange[key] = twoYearsAvailabiltyCheckout[key];
                    }
                }
            });
            return newDateRange;
        }
    };
    var isAvailableForSelectedRange = function() {
        if (datePickerMode() == LgConsts/* default.datePickerModeForCheckout */.Z.datePickerModeForCheckout) {
            var newDateRange = {};
            var checkinDateObject = new Date(checkin);
            var availabilityFlag = 0;
            var counter = 0;
            Object.keys(twoYearsAvailabiltyCheckout).forEach(function(key, index, item) {
                var theDateToCheck = new Date(twoYearsAvailabiltyCheckout[key]["date"]);
                var theDateToCheckAvailability = twoYearsAvailabiltyCheckout[key]["status"];
                if (theDateToCheck > checkinDateObject) {
                    counter++;
                    if (counter == minStayToCheck && availabilityFlag == 0) {
                        availabilityFlag = 1;
                    }
                    if (availabilityFlag == 1) {
                        if (theDateToCheckAvailability != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                            availabilityFlag = 2;
                        }
                        newDateRange[key] = twoYearsAvailabiltyCheckout[key];
                    }
                }
            });
            return newDateRange;
        }
    };
    var disabledDaysHandler = function(dateParam) {
        if (props.forList) {
            return false;
        }
        if (isOpenCalendar == 1) {
            return false;
        }
        var today = dayjs_min_default()();
        var diffFromToday = Math.abs(dateParam.diff(today.format("YYYY-MM-DD"), "day"));
        if (diffFromToday < bookingMaxInAdvance) {
            return true;
        }
        var theDateToCheck = dayjs_min_default()(dateParam).format("YYYY-MM-DD") //dateParam.toISOString().slice(0, 10)
        ;
        // .toISOString().split('T')[0];
        var currentAvailability = twoYearsAvailabilty;
        if (datePickerMode() == LgConsts/* default.datePickerModeForCheckout */.Z.datePickerModeForCheckout) {
            currentAvailability = dateRangeForCheckout;
        }
        if (datePickerMode() == LgConsts/* default.datePickerModeForCheckin */.Z.datePickerModeForCheckin && currentAvailability[theDateToCheck] != undefined && (currentAvailability[theDateToCheck]["checkinAllowed"] == false || currentAvailability[theDateToCheck]["checkinOrCheckoutRequired"] == false)) {
            return true;
        }
        if (datePickerMode() == LgConsts/* default.datePickerModeForCheckout */.Z.datePickerModeForCheckout && currentAvailability != undefined && currentAvailability[theDateToCheck] != undefined && (currentAvailability[theDateToCheck]["checkoutAllowed"] == false || currentAvailability[theDateToCheck]["checkinOrCheckoutRequired"] == false)) {
            return true;
        }
        if (theDateToCheck == checkin) {
            return true;
        }
        if (currentAvailability != null && currentAvailability[theDateToCheck] != undefined && currentAvailability[theDateToCheck]["status"] == LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
            return false;
        } else {
            return true;
        }
    };
    (0,react.useEffect)(function() {
        setDateRangeForCheckout(dateRangeForCheckoutHandler());
    }, [
        checkin,
        checkout
    ]);
    var datePickerClassHandler = function(dateParam) {
        if (props.forList) {
            return false;
        }
        var className = "";
        var mode = datePickerMode();
        var theDateToCheck = dayjs_min_default()(dateParam).format("YYYY-MM-DD") //dateParam.toISOString().slice(0, 10)
        ;
        var checkinDateObject = new Date(checkin);
        var checkoutDateObject = new Date(checkout);
        var theDateToCheckObject = new Date(theDateToCheck);
        if (mode == LgConsts/* default.datePickerModeForCheckin */.Z.datePickerModeForCheckin) {
            if (twoYearsAvailabilty[theDateToCheck] == undefined) {
                return className;
            }
            if (twoYearsAvailabiltyCheckout[theDateToCheck] == undefined) {
                return className;
            }
            if (twoYearsAvailabilty[theDateToCheck]["status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL && twoYearsAvailabiltyCheckout[theDateToCheck]["status"] == LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                className = "date-picker-item-inactive";
                return className;
            } else if (twoYearsAvailabilty[theDateToCheck]["status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                className = "date-picker-item-line-through";
                return className;
            }
        } else if (mode == LgConsts/* default.datePickerModeForCheckout */.Z.datePickerModeForCheckout) {
            if (theDateToCheckObject >= checkinDateObject && twoYearsAvailabiltyCheckout[theDateToCheck]["status"] == LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                return className;
            } else {
                className = "date-picker-item-line-through";
                return className;
            }
        } else if (mode == LgConsts/* default.datePickerModeResetRange */.Z.datePickerModeResetRange) {
            if (twoYearsAvailabilty[theDateToCheck] == undefined) {
                return className;
            }
            if (twoYearsAvailabiltyCheckout[theDateToCheck] == undefined) {
                return className;
            }
            if (twoYearsAvailabilty[theDateToCheck]["status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL && twoYearsAvailabiltyCheckout[theDateToCheck]["status"] == LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                className = "date-picker-item-inactive";
                return className;
            } else if (twoYearsAvailabilty[theDateToCheck]["status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                className = "date-picker-item-line-through";
                return className;
            }
        }
        return className;
    };
    var toolTipHandler = function(dateParam) {
        if (props.forList) {
            return false;
        }
        var mode = datePickerMode();
        var tooltipCheckin = "";
        var tooltipCheckout = "";
        // if(isMobile){ return ''}
        var theDateToCheck = dayjs_min_default()(dateParam).format("YYYY-MM-DD") //dateParam.toISOString().slice(0, 10)
        ;
        var checkinDateObject = new Date(checkin);
        var checkoutDateObject = new Date(checkout);
        var theDateToCheckObject = new Date(theDateToCheck);
        if (twoYearsAvailabilty[theDateToCheck] != undefined) {
            tooltipCheckin = twoYearsAvailabilty[theDateToCheck].status_desc;
        }
        if (twoYearsAvailabiltyCheckout[theDateToCheck] != undefined) {
            // tooltipCheckout = twoYearsAvailabiltyCheckout[theDateToCheck].status_desc + " / minimum stay:" + twoYearsAvailabilty[theDateToCheck]['min_stay']
            tooltipCheckout = "minimum stay: " + twoYearsAvailabilty[theDateToCheck]["min_stay"];
        }
        if (mode == LgConsts/* default.datePickerModeForCheckin */.Z.datePickerModeForCheckin && twoYearsAvailabiltyCheckout[theDateToCheck] != undefined && twoYearsAvailabilty[theDateToCheck]["checkinAllowed"] == false) {
            tooltipCheckin = "Not available for check-in";
        }
        if (mode == LgConsts/* default.datePickerModeForCheckout */.Z.datePickerModeForCheckout && twoYearsAvailabiltyCheckout[theDateToCheck] != undefined && twoYearsAvailabilty[theDateToCheck]["checkoutAllowed"] == false) {
            tooltipCheckin = "Not available for check-out";
        }
        if (mode == LgConsts/* default.datePickerModeForCheckin */.Z.datePickerModeForCheckin) {
            if (twoYearsAvailabilty[theDateToCheck] != undefined && twoYearsAvailabilty[theDateToCheck]["status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL && twoYearsAvailabiltyCheckout[theDateToCheck]["status"] == LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL && twoYearsAvailabiltyCheckout[theDateToCheck]["temp_status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                return twoYearsAvailabiltyCheckout[theDateToCheck]["status_desc"];
            }
            return tooltipCheckin //+ " - " + tooltipCheckin
            ;
        }
        if (mode == LgConsts/* default.datePickerModeForCheckout */.Z.datePickerModeForCheckout) {
            if (disabledDaysHandler(dateParam) && theDateToCheck != checkin) {
                tooltipCheckout = "minimum stay violation";
            }
            if (twoYearsAvailabilty[theDateToCheck] != undefined && twoYearsAvailabilty[theDateToCheck]["status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL && twoYearsAvailabilty[theDateToCheck]["temp_status"] == LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                tooltipCheckout = "minimum stay: " + twoYearsAvailabilty[checkin]["min_stay"];
            }
            return tooltipCheckout;
        }
        if (theDateToCheckObject >= checkinDateObject && theDateToCheckObject <= checkoutDateObject) {
            if (mode == LgConsts/* default.datePickerModeResetRange */.Z.datePickerModeResetRange) {
                if (disabledDaysHandler(dateParam) && theDateToCheck != checkin) {
                    tooltipCheckout = "minimum stay violation";
                }
                if (twoYearsAvailabilty[theDateToCheck] != undefined && twoYearsAvailabilty[theDateToCheck]["status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL && twoYearsAvailabilty[theDateToCheck]["temp_status"] == LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                    tooltipCheckout = "minimum stay: " + twoYearsAvailabilty[checkin]["min_stay"];
                }
                if (twoYearsAvailabilty[theDateToCheck] != undefined && twoYearsAvailabilty[theDateToCheck]["status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL && twoYearsAvailabiltyCheckout[theDateToCheck]["status"] == LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL && twoYearsAvailabiltyCheckout[theDateToCheck]["temp_status"] != LgConsts/* default.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL */.Z.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL) {
                    return twoYearsAvailabiltyCheckout[theDateToCheck]["status_desc"];
                }
                return tooltipCheckout;
            }
            return "";
        } else {
            return tooltipCheckin;
        }
        return null;
    };
    var ModalActionBar = function(param) {
        var onAccept = param.onAccept, onCancel = param.onCancel, onClear = param.onClear, onSetToday = param.onSetToday;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "d-flex flex-row-reverse p-b-20 m-l-15 m-r-15",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "btn-design-color btn btn-primary text-lowercase",
                        onClick: function() {
                            return setOpenState(false);
                        },
                        children: " close "
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: " text-lowercase",
                        onClick: function() {
                            return dispatch((0,actions/* setDateRange */.t5)([
                                null,
                                null
                            ]));
                        },
                        children: " clear "
                    })
                })
            ]
        });
    };
    var SwipperActionBar = function(param) {
        var onAccept = param.onAccept, onCancel = param.onCancel, onClear = param.onClear, onSetToday = param.onSetToday;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    // const uiSearchBarDivHeight = useSelector(state => state['uiData']['searchBarDivHeight'])
    //
    // const propertiesParams = useSelector(state => state['propertiesParams']);
    var onChangeHandler = function(newValue) {
        var startDate = cloneDeep_default()(newValue[0]);
        var endDate = cloneDeep_default()(newValue[1]);
        if (startDate == null && endDate != null) {
            startDate = cloneDeep_default()(endDate);
            endDate = null;
        }
        if (Checkers/* default.isValidDate */.Z.isValidDate(checkin) && Checkers/* default.isValidDate */.Z.isValidDate(checkout)) {
            // console.log("forDebug", "case 3")
            endDate = null;
        }
        if (Checkers/* default.isValidDate */.Z.isValidDate(checkin) && !Checkers/* default.isValidDate */.Z.isValidDate(checkout) && startDate != null && endDate == null) {
            endDate = cloneDeep_default()(startDate);
            startDate = dayjs_min_default()(checkin);
        }
        dispatch((0,actions/* setDateRange */.t5)([
            startDate,
            endDate
        ]));
    // if (props.forList && startDate != null && endDate != null) {
    //     let parameters = cloneDeep(propertiesParams);
    //     parameters.checkin = startDate.format("YYYY-MM-DD")
    //     parameters.checkout = endDate.format("YYYY-MM-DD")
    //     dispatch(setOffset(0))
    //     dispatch(setPageNumber(1))
    //     dispatch<any>(fetchPropertiesAction(parameters, 0, uiSearchBarDivHeight))
    //     props.toggleDrawer(false)
    // }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
            onClickAway: function() {
                return setOpenState(false);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12 text-left " + containerClass,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                    dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: props.theme,
                        children: props.isStatic == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangePicker/* DateRangePicker */.D, {
                            value: value,
                            autoFocus: true,
                            inputFormat: "DD/MM/YYYY",
                            showToolbar: false,
                            disablePast: true,
                            onChange: function(newValue) {
                                return onChangeHandler(newValue);
                            },
                            components: {
                                ActionBar: ModalActionBar
                            },
                            open: openState,
                            onAccept: function(newDate) {
                                if (newDate[0] != null && newDate[1] != null) {
                                    setOpenState(false);
                                }
                            },
                            startText: "Add date",
                            endText: "Add date",
                            PopperProps: {
                                placement: "bottom-end"
                            },
                            shouldDisableDate: function(dateParam) {
                                return disabledDaysHandler(dateParam);
                            },
                            renderInput: function(startProps, endProps) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-6 pe-1 text-left",
                                            onClick: function() {
                                                return setOpenState(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: "form-group-default-checkin",
                                                className: "form-group form-group-default form-group-default-checkin",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        id: "checkin_label",
                                                        className: "form-label bold text-left",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                className: "hidden-md",
                                                                icon: pro_regular_svg_icons/* faCalendar */.fT7
                                                            }),
                                                            "\xa0Check in"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, startProps), {
                                                            autoComplete: "off"
                                                        }))
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-6 ps-1 text-left",
                                            onClick: function() {
                                                return setOpenState(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: "form-group-default-checkout",
                                                className: "form-group form-group-default form-group-default-checkout",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        id: "checkout_label",
                                                        className: "form-label bold text-left",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                className: "hidden-md",
                                                                icon: pro_regular_svg_icons/* faCalendar */.fT7
                                                            }),
                                                            "\xa0Check out"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, endProps), {
                                                            autoComplete: "off"
                                                        }))
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            },
                            renderDay: function(day, pickersDayProps) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomDateRangePickerDay, {
                                    pickersDayProps: pickersDayProps,
                                    toolTipHandler: toolTipHandler,
                                    datePickerClassHandler: datePickerClassHandler
                                }, pickersDayProps.key);
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticDateRangePicker/* StaticDateRangePicker */.u, {
                            calendars: 1,
                            showToolbar: false,
                            value: value,
                            onChange: function(newValue) {
                                return onChangeHandler(newValue);
                            },
                            renderInput: function(startProps, endProps) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                            },
                            components: {
                                ActionBar: SwipperActionBar
                            },
                            disablePast: true,
                            startText: "Add date",
                            endText: "Add date",
                            shouldDisableDate: function(dateParam) {
                                return disabledDaysHandler(dateParam);
                            },
                            renderDay: function(day, pickersDayProps) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomDateRangePickerDay, {
                                    pickersDayProps: pickersDayProps,
                                    toolTipHandler: toolTipHandler,
                                    datePickerClassHandler: datePickerClassHandler
                                }, pickersDayProps.key);
                            }
                        })
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 75082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76710);

var LgConsts = function LgConsts() {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, LgConsts);
};
LgConsts.AVAILABILITY_59_AVAILABLE_FOR_ARRIVAL = "59";
LgConsts.AVAILABILITY_60_UNAVAILABLE = 60;
LgConsts.AVAILABILITY_61_BOOKED = 61;
LgConsts.AVAILABILITY_62_CLOSED = 62;
LgConsts.AVAILABILITY_63_STOP_SALES = 63;
LgConsts.AVAILABILITY_185_NOT_AVAILABLE_FOR_ARRIVAL = 185;
LgConsts.datePickerModeForCheckin = "forCheckIn";
LgConsts.datePickerModeForCheckout = "forCheckOut";
LgConsts.datePickerModeResetRange = "resetRange";
LgConsts.BOOKING_TYPE_1_INQUIRIES = "1";
LgConsts.BOOKING_TYPE_2_WEBHOTELIER = "2";
LgConsts.PROPERTY_TYPE_2_HOTEL = 2;
/* harmony default export */ __webpack_exports__["Z"] = (LgConsts);


/***/ }),

/***/ 74867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27305);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37130);



var Calendar = /*#__PURE__*/ function() {
    "use strict";
    function Calendar(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Calendar);
        Calendar.setProps(props);
        Calendar.setValue(null);
    }
    Calendar.setProps = function setProps(props) {
        this.props = props;
    };
    Calendar.setValue = function setValue(date) {
        this.value = date;
    };
    Calendar.setTextColor = function setTextColor(textColor) {
        this.textColor = textColor;
    };
    Calendar.setBorderColor = function setBorderColor(borderColor) {
        this.borderColor = borderColor;
    };
    Calendar.setButtonColor = function setButtonColor(buttonColor) {
        this.buttonColor = buttonColor;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Calendar, null, [
        {
            key: "getValue",
            get: function get() {
                return this.value;
            }
        },
        {
            key: "getTextColor",
            get: function get() {
                return this.textColor;
            }
        },
        {
            key: "getBorderColor",
            get: function get() {
                return this.borderColor;
            }
        },
        {
            key: "getButtonColor",
            get: function get() {
                return this.buttonColor;
            }
        },
        {
            key: "getCalendarMaterialTheme",
            get: function get() {
                //----------------CALENDAR INIT STYLES------------------
                return (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    components: {
                        MuiFormLabel: {
                            styleOverrides: {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                //@ts-ignore
                                root: {
                                    position: "absolute !important",
                                    marginLeft: "-14px !important",
                                    marginTop: "-16px !important",
                                    fontSize: "14px !important",
                                    opacity: ".7 !important",
                                    color: this.props.hasOwnProperty("fullWidthBar") ? this.props.searchbarThemeColor != null ? !this.props.searchbarThemeColor ? "#fff!important" : "#000!important" : this.props.designMode ? "#fff!important" : "#000!important" : "#000!important"
                                }
                            }
                        },
                        MuiInputLabel: {
                            styleOverrides: {
                                shrink: {
                                    display: "none!important"
                                }
                            }
                        },
                        MuiFormControl: {
                            styleOverrides: {
                                root: {
                                    width: "-webkit-fill-available"
                                }
                            }
                        },
                        MuiOutlinedInput: {
                            styleOverrides: {
                                input: {
                                    padding: "1px 0",
                                    fontSize: "14px",
                                    color: this.props.hasOwnProperty("fullWidthBar") ? this.props.searchbarThemeColor != null ? !this.props.searchbarThemeColor ? "#fff" : "#000" : this.props.designMode ? "#fff" : "#000" : "#000"
                                },
                                notchedOutline: {
                                    display: "none!important"
                                }
                            }
                        },
                        MuiPaper: {
                            styleOverrides: {
                                root: {
                                    margin: "15px 0 35px 0",
                                    borderRadius: this.props != undefined && this.props.searchbarRadius != null ? this.props.searchbarRadius + "px" : "10px"
                                }
                            }
                        }
                    }
                });
            }
        }
    ]);
    return Calendar;
}();
/* harmony default export */ __webpack_exports__["Z"] = (Calendar);


/***/ }),

/***/ 42970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27305);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37130);



var Dialog = /*#__PURE__*/ function() {
    "use strict";
    function Dialog(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Dialog);
        Dialog.setProps(props);
    }
    Dialog.setProps = function setProps(props) {
        this.props = props;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Dialog, null, [
        {
            key: "getDialogMaterialTheme",
            get: function get() {
                return (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    components: {
                        MuiPaper: {
                            styleOverrides: {
                                root: {
                                    borderRadius: this.props != undefined && this.props.searchbarRadius != null ? this.props.searchbarRadius + "px" : "10px"
                                }
                            }
                        }
                    }
                });
            }
        }
    ]);
    return Dialog;
}();
/* harmony default export */ __webpack_exports__["Z"] = (Dialog);


/***/ }),

/***/ 22019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27305);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37130);




var Popover = /*#__PURE__*/ function() {
    "use strict";
    function Popover(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Popover);
        Popover.setProps(props);
        Popover.setOpen(false);
        Popover.setPopoverAnchorEl(null);
        Popover.setPopoverOpen(Boolean(Popover.getPopoverAnchorEl));
    }
    Popover.setProps = function setProps(props) {
        this.props = props;
    };
    Popover.setOpen = function setOpen(open) {
        this.open = open;
    };
    Popover.setPopoverAnchorEl = function setPopoverAnchorEl(popoverAnchorEl) {
        this.popoverAnchorEl = popoverAnchorEl;
    };
    Popover.setPopoverOpen = function setPopoverOpen(popoverOpen) {
        this.popoverOpen = popoverOpen;
    };
    Popover.test = function test() {
        var popover_id = this.getPopoverOpen ? "simple-popover" : undefined;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), adults_amount = ref[0], adults_setAmount = ref[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), kids_amount = ref1[0], kids_setAmount = ref1[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), infants_amount = ref2[0], infants_setAmount = ref2[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), adults_decreaseHidden = ref3[0], adults_setDecreaseHidden = ref3[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), kids_decreaseHidden = ref4[0], kids_setDecreaseHidden = ref4[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), infants_decreaseHidden = ref5[0], infants_setDecreaseHidden = ref5[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), adults_increaseHidden = ref6[0], adults_setIncreaseHidden = ref6[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), kids_increaseHidden = ref7[0], kids_setIncreaseHidden = ref7[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), infants_increaseHidden = ref8[0], infants_setIncreaseHidden = ref8[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("Who"), guests_text = ref9[0], guests_setText = ref9[1];
        var guests_sum = null;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Popover, null, [
        {
            key: "getOpen",
            get: function get() {
                return this.open;
            }
        },
        {
            key: "getPopoverAnchorEl",
            get: function get() {
                return this.popoverAnchorEl;
            }
        },
        {
            key: "getPopoverOpen",
            get: function get() {
                return this.popoverOpen;
            }
        },
        {
            key: "getPopoverId",
            get: function get() {
                return this.getPopoverOpen ? "simple-popover" : undefined;
            }
        },
        {
            key: "getPopoverMaterialTheme",
            get: function get() {
                return (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    components: {
                        MuiPaper: {
                            styleOverrides: {
                                root: {
                                    margin: "15px 0 35px 0",
                                    borderRadius: this.props != undefined && this.props.searchbarRadius != null ? this.props.searchbarRadius + "px" : "10px"
                                }
                            }
                        }
                    }
                });
            }
        }
    ]);
    return Popover;
}();
Popover.popoverHandleOpen = function(event) {
    Popover.setPopoverAnchorEl(event.currentTarget);
    document.getElementById("guests_label").classList.add("fade");
    document.getElementById("guests_label").parentElement.classList.add("focused");
};
Popover.popoverHandleClose = function() {
    document.getElementById("guests_label").classList.remove("fade");
    document.getElementById("guests_label").parentElement.classList.remove("focused");
    Popover.setPopoverAnchorEl(null);
};
/* harmony default export */ __webpack_exports__["Z"] = (Popover);


/***/ })

}]);